export const ueberAutoeinfachlos = [
  {
    id: 1,
    title: "Was ist Autoeinfachlos?",
    text: (
      <>
        <p>
          Autoeinfachlos ist ein schnell wachsendes Marktplatz für
          Gebrauchtwagen in Österreich.
        </p>

        <p>
          Wir verbinden Menschen, die ihr Auto verkaufen möchten, direkt mit
          unserem Netzwerk von über 5.000 verifizierten Autohändlern. Dabei
          stellen wir sicher, dass jeder Verkäufer mit dem Händler
          zusammengeführt wird, der sein Auto am meisten kaufen möchte und den
          besten Preis bezahlt. Indem wir Zwischenhändler ausschalten und den
          Prozess online abwickeln, sorgen wir dafür, dass unser Kunden schnell,
          sicher und ohne das Haus zu verlassen ein besseres Angebot erhalten.
        </p>

        <p>
          84% unserer Kunden erzielen einen höheren Preis, wenn sie über
          Autoeinfachlos verkaufen.
        </p>

        <h3>
          Wir helfen Menschen, ihre Autos an verifizierte Händler zu verkaufen
        </h3>
        <p>
          Sobald dein Auto im täglichen Online-Verkauf gelistet ist, wird
          innerhalb von 24 Stunden ein Verkauf vereinbart.
        </p>

        <h3>Wir führen dich online durch den gesamten Prozess</h3>
        <p>
          Wir helfen dir, ein professionelles Online-Profil für dein Fahrzeug zu
          erstellen, basierend auf deiner Bewertung und den Fahrzeugdetails, die
          du uns zur Verfügung stellst.
        </p>

        <p>
          Wir unterstützen dich dabei, einen realistischen Richtpreis
          festzulegen und teilen die Details deines Fahrzeugs in unserer
          täglichen Online-Auktion mit tausenden verifizierten Händlern in ganz
          Österreich.
        </p>

        <h3>Wir präsentieren dir das beste Angebot für dein Auto</h3>
        <p>
          Danach kannst du die Abholung bei dir zu Hause und die sichere Zahlung
          schnell und einfach arrangieren.
        </p>

        <h3>Verkaufen auf Autoeinfachlos ist 100 % kostenlos</h3>
        <p>
          Dies beinhaltet die Abholung von zu Hause und die sichere Überweisung
          per Bank. Verkaufen ist einfach – der Autoeinfachlos-Weg.
        </p>
      </>
    ),
    metaTitle:
      "Was ist Autoeinfachlos? – Der einfache Weg, dein Auto sicher zu verkaufen",
    metaDescription:
      "Autoeinfachlos verbindet dich mit über 5.000 verifizierten Händlern für den besten Preis. Verkaufe dein Auto schnell, sicher und kostenlos – bequem von zu Hause aus!",
    link: "/was-ist-autoeinfachlos",
  },
  {
    id: 2,
    title:
      "Ist Autoeinfachlos eine sichere Plattform, um dein Auto zu verkaufen?",
    text: (
      <>
        <p>
          Ja, der Verkauf über Autoeinfachlos ist völlig sicher. Du erhältst
          eine sichere Zahlung direkt von einem verifizierten Händler auf dein
          Bankkonto.
        </p>
        <p>So sorgt Autoeinfachlos für deine Sicherheit:</p>

        <h3>Nur verifizierte Händler in unserem Netzwerk</h3>
        <ul className="gestrichelt-antwort">
          <li>
            Händler, die unserem Netzwerk beitreten möchten, werden gründlich
            überprüft. Das stellt sicher, dass nur seriöse und vertrauenswürdige
            Käufer zugelassen werden.
          </li>
        </ul>

        <h3>Deine Kontaktdaten bleiben privat</h3>
        <ul className="gestrichelt-antwort">
          <li>
            Beim Anlegen des Fahrzeugprofils nutzen wir deine Fahrgestellnummer,
            um die Fahrzeugdaten abzurufen, sowie deine E-Mail-Adresse und
            Telefonnummer, um mit dir in Kontakt zu bleiben. Deine Kontaktdaten
            bleiben privat; sie werden nur an den Käufer weitergegeben, nachdem
            du sein Angebot akzeptiert hast.
          </li>
        </ul>

        <h3>Kostenlose Abholung durch vertrauenswürdige Partner</h3>
        <ul className="gestrichelt-antwort">
          <li>
            Sobald du das beste Angebot akzeptierst, teilen wir deine
            Kontaktdaten dem Käufer mit, um die Abholung an deinem bevorzugten
            Standort zu arrangieren – in der Regel bei dir zu Hause oder an
            deinem Arbeitsplatz.
          </li>
        </ul>

        <p>
          Falls du Unterstützung benötigst, steht dir unser Sales Support Team
          zur Verfügung:
        </p>

        <p>
          <strong>Hotline: </strong> +43 720 881186
        </p>
        <ul className="gepunktete-antwort">
          <li>Montag bis Freitag: 9:00 bis 19:00 Uhr</li>
          <li>Feiertage: 10:00 bis 17:00 Uhr</li>
        </ul>

        <p>
          <strong>Email: </strong> kundenservice@autoeinfachlos.at
        </p>
        <ul className="gepunktete-antwort">
          <li>Für eine schnellere Antwort erreichbar</li>
        </ul>
      </>
    ),
    metaTitle:
      "Ist Autoeinfachlos eine sichere Plattform, um dein Auto zu verkaufen?",
    metaDescription:
      "Erfahre, wie Autoeinfachlos für Sicherheit sorgt: Verifizierte Händler, privater Datenschutz und sichere Zahlungen. So verkaufst du dein Auto ohne Sorgen.",
    link: "/ist-autoeinfachlos-sicher",
  },
  {
    id: 3,
    title: "Ist Autoeinfachlos dasselbe wie Wirkaufendeinauto?",
    text: (
      <>
        <p>
          Nein, Autoeinfachlos bietet einen völlig anderen Service als
          wirkaufendeinauto. Autoeinfachlos ist ein Online-Marktplatz für
          Gebrauchtwagen, der Autoverkäufer direkt mit verifizierten Händlern
          verbindet und die Autos zum Bestpreis innerhalb von 24 Stunden
          verkauft.
        </p>
        <p>
          Wirkaufendeinauto hingegen ist eine Ankaufsplattform, die Fahrzeuge
          kauft und anschließend weiterverkauft.
        </p>
        <h3>Autoeinfachlos verbindet Verkäufer und Händler</h3>
        <p>
          Wir bringen Menschen, die ihr Auto verkaufen möchten, direkt mit
          unserem Netzwerk von über 5.000 verifizierten Autohändlern zusammen
          und stellen sicher, dass jeder Verkäufer mit dem Händler gematcht
          wird, der am meisten Interesse an seinem Fahrzeug hat.
        </p>
        <h3>Autoeinfachlos kauft dein Auto nicht</h3>
        <p>
          Der Verkauf erfolgt direkt zwischen dir und dem Händler mit dem besten
          Angebot.
        </p>
        <h3>
          Du musst nicht zu einem Standort für eine Vor-Ort-Inspektion fahren
        </h3>
        <p>
          Mit Autoeinfachlos erstellst du das Profil deines Autos bequem über
          dein Handy, indem du Fragen zur Ausstattung und zum Zustand
          beantwortest und Fotos hinzufügst.
        </p>
        <h3>Wir finden das höchste Angebot für dein Auto</h3>
        <p>
          Wir ermitteln das beste Angebot für dein Auto, indem wir über 5.000
          verifizierte Händler in unserem Netzwerk einladen, sich in täglichen
          Online-Auktionen mit ihren besten Preisen zu überbieten. Du erhältst
          eine Benachrichtigung mit allen Details zu deinem Angebot, sobald die
          Auktion abgeschlossen ist.
        </p>
        <h3>Kostenlose Abholung von zu Hause</h3>
        <p>
          Mit dem Angebot in der Hand musst du nur noch die kostenlose Abholung
          mit deinem Käufer vereinbaren. Der Händler kommt zu dir nach Hause
          oder zur Arbeit, wann immer es für dich passt, um den Verkauf
          abzuschließen.
        </p>
        <h3>Sofortige Zahlung</h3>
        <p>
          Vor Ort überprüft der Händler dein Auto. Wenn alles deinem Profil
          entspricht, erfolgt die Zahlung sofort an dich und, falls zutreffend,
          an deinen Finanzierungsanbieter, bevor der Händler dein Auto mitnimmt.
        </p>
      </>
    ),

    metaTitle:
      "Ist Autoeinfachlos dasselbe wie Wirkaufendeinauto? – Unterschiede erklärt",
    metaDescription:
      "Autoeinfachlos verbindet dich direkt mit Händlern und verkauft dein Auto zum Bestpreis – sicher, bequem und ohne Standortbesuch. Erfahre, wie wir uns von Wirkaufendeinauto unterscheiden!",
    link: "/vergleich-wirkaufendeinauto",
  },
  {
    id: 4,
    title: "Kauft Autoeinfachlos mein Auto?",
    text: (
      <>
        <p>
          Autoeinfachlos ist ein Online-Marktplatz, der Menschen, die ihr Auto
          verkaufen möchten, direkt mit unserem Netzwerk von über 5.000
          verifizierten Autohändlern verbindet.
        </p>
        <p>
          Wir stellen sicher, dass jeder Verkäufer auf unserer Plattform mit dem
          Händler gematcht wird, der das größte Interesse an seinem Fahrzeug
          hat. Wenn du dein Auto in unseren täglichen Online-Verkauf einträgst,
          bieten die Händler um den besten Preis für dein Fahrzeug. Am Ende des
          Verkaufsprozesses senden wir dir das höchste Angebot und unterstützen
          dich beim Verkauf deines Autos an den entsprechenden Händler.
        </p>
      </>
    ),

    metaTitle:
      "Kauft Autoeinfachlos mein Auto? – So funktioniert der Verkaufsprozess",
    metaDescription:
      "Autoeinfachlos kauft dein Auto nicht selbst, sondern verbindet dich mit über 5.000 verifizierten Händlern, um dir den besten Preis zu bieten. Wie der Verkaufsprozess funktioniert und warum du das beste Angebot erhältst, erfährst du hier...",
    link: "/kauft-autoeinfachlos-mein-auto",
  },
  {
    id: 5,
    title: "Ist es kompliziert, ein Auto auf Autoeinfachlos zu verkaufen?",
    text: (
      <>
        <p>
          Nein – es ist ganz einfach, dein Auto über Autoeinfachlos zu
          verkaufen. Die Schritte sind:
        </p>
        <ul className="nummerierte-antwort">
          <li>
            Gib deine Fahrzeugdaten ein, z. B. Marke, Modell, Baujahr und
            Kilometerstand.
          </li>
          <li>
            Du erhältst sofort eine Bewertung deines Fahrzeugs, damit du weißt,
            was es wert ist.
          </li>
          <li>
            Wenn du an einem Verkauf interessiert bist, setzt sich ein
            Mitarbeiter mit dir in Verbindung, um den Richtpreis festzulegen.
          </li>
          <li>
            Dein Fahrzeug wird unseren 5.000 Händlern vorgestellt, und du
            erhältst das beste Angebot – ohne Abzüge und Gebühren.
          </li>
          <li>
            Akzeptiere das Angebot und vereinbare eine kostenlose Abholung mit
            dem Händler zu einem für dich passenden Zeitpunkt.
          </li>
        </ul>
      </>
    ),

    metaTitle:
      "Ist es kompliziert, ein Auto auf Autoeinfachlos zu verkaufen? – Einfach erklärt",
    metaDescription:
      "Nein, der Verkauf auf Autoeinfachlos ist einfach: Fahrzeugdaten eingeben, Bewertung erhalten, Angebot akzeptieren und kostenlose Abholung vereinbaren.",
    link: "/ist-es-kompliziert",
  },
];

export const verkaufenMitAutoeinfachlos = [
  {
    id: 1,
    title: "Wie finden wir das höchste Angebot für dein Auto?",
    text: (
      <>
        <p>
          Wir ermitteln dein höchstes Angebot, indem wir über 5.000
          verifizierten Händlern in unserem Netzwerk die Möglichkeit geben, in
          einer täglichen Auktion um dein Auto zu bieten. Die Händler können die
          Beschreibung und Fotos deines Fahrzeugs einsehen (das Kennzeichen und
          deine privaten Daten bleiben dabei unkenntlich) und ein Gebot abgeben.
        </p>

        <p>
          Die Händler sehen auch deinen Richtpreis, der den Betrag angibt, mit
          dem du zufrieden bist. Dieser Richtpreis dient jedoch nur als
          Orientierung. Da die Händler gegeneinander bieten, kann es sein, dass
          du deutlich mehr als diesen Betrag erhältst. Unsere täglichen
          Auktionen sind sehr wettbewerbsorientiert, mit Händlern aus ganz
          Österreich, die dir den besten Preis bieten möchten. So ist es kein
          Wunder, dass mehr als hälfte der Fahrzeuge, die zum Richtpreis
          eingestellt werden, letztlich zu einem höheren Preis verkauft werden!
        </p>

        <p>
          Sobald die Händler ihre Gebote abgegeben haben und die tägliche
          Auktion endet, teilen wir dir noch am selben Tag dein höchstes Angebot
          mit. Du kannst dieses Angebot sofort annehmen, um den Verkauf
          voranzutreiben.
        </p>

        <p>
          Nachdem du dein höchstes Angebot angenommen hast, wird sich der
          Händler mit dir in Verbindung setzen, um eine Abholung zu einem für
          dich passenden Zeitpunkt zu vereinbaren. Alle unsere Händler holen
          dein Auto kostenlos ab und sorgen für eine schnelle, kostenlose
          Überweisung auf dein Bankkonto, um den Verkauf abzuschließen.
        </p>
      </>
    ),
    metaTitle:
      "Wie finden wir das höchste Angebot für dein Auto? – Autoeinfachlos erklärt",
    metaDescription:
      "Wir finden dein höchstes Angebot durch tägliche Auktionen mit über 5.000 verifizierten Händlern. Erhalte den besten Preis für dein Auto und verkaufe schnell und einfach",
    link: "/hoechste-angebot-erklaert",
  },
  {
    id: 2,
    title: "Wie lange dauert der Verkauf über Autoeinfachlos?",
    text: (
      <>
        <p>
          Von der kostenlosen Sofortbewertung bis zur Verkaufsbestätigung dauert
          es in der Regel zwei Tage, manchmal kann der Verkauf sogar innerhalb
          von 24 Stunden abgeschlossen werden. Die Dauer hängt davon ab, wie
          schnell du dein Fahrzeugprofil inklusive Fotos vervollständigst.
        </p>
        <p>
          Sobald der Verkauf abgeschlossen ist, kannst du die Abholung und
          Zahlung mit dem Käuferhändler abstimmen. Die Abholung erfolgt in der
          Regel innerhalb einer Woche nach Verkaufsvereinbarung. Die Zahlung
          wird direkt bei der Abholung auf dein Bankkonto überwiesen. Unser
          <a href="/" target="_blank" className="FragenAntworten-link">
            Verkaufssupport-Team
          </a>
          steht dir jederzeit zur Verfügung, um sicherzustellen, dass dein
          Verkauf reibungslos verläuft.
        </p>
      </>
    ),
    metaTitle: "Wie lange dauert der Verkauf über Autoeinfachlos?",
    metaDescription:
      "Der Verkauf über Autoeinfachlos dauert in der Regel nur zwei Tage. Mit vollständigem Fahrzeugprofil ist dein Auto oft schon innerhalb von 24 Stunden verkauft.",
    link: "/verkaufsdauer",
  },
  {
    id: 3,
    title:
      "Welche Gebühren fallen beim Verkauf meines Fahrzeugs über Autoeinfachlos an?",
    text: (
      <>
        <p>
          Der Verkauf deines Fahrzeugs über Autoeinfachlos ist vollkommen
          kostenlos. Es gibt keine Gebühren. Die Händler zahlen für den Kauf und
          die Abholung deines Fahrzeugs, sodass du keinen Cent zahlen musst.
        </p>
      </>
    ),

    metaTitle: "Welche Gebühren fallen beim Verkauf über Autoeinfachlos an?",
    metaDescription:
      "Der Verkauf über Autoeinfachlos ist 100 % kostenlos. Keine Gebühren, keine versteckten Kosten – die Händler zahlen für den Kauf und die Abholung deines Fahrzeugs",
    link: "/gebuehren",
  },
  {
    id: 4,
    title:
      "Was sind die wichtigsten Schritte beim Verkauf über Autoeinfachlos?",
    text: (
      <>
        <ul className="nummerierte-antwort">
          <li>
            <strong>Fahrzeugprofil erstellen </strong>
            <p>
              Wir stellen sicher, dass jeder Verkäufer auf unserer Plattform mit
              dem Händler gematcht wird, der das größte Interesse an seinem
              Fahrzeug hat. Wenn du dein Auto in unseren täglichen
              Online-Verkauf einträgst, bieten die Händler um den besten Preis
              für dein Fahrzeug. Am Ende des Verkaufsprozesses senden wir dir
              das höchste Angebot und unterstützen dich beim Verkauf deines
              Autos an den entsprechenden Händler.
            </p>
          </li>
          <li>
            <strong>Wir legen los</strong>
            <p>
              Wir informieren unser Netzwerk von über 5.000 verifizierten
              Händlern über dein Fahrzeug und laden sie ein, in einer täglichen
              Online-Auktion Gebote abzugeben.
            </p>
          </li>
          <li>
            <strong>Erhalte das höchste Angebot</strong>
            <p>
              Wir präsentieren dir das höchste Angebot aus der Auktion zur
              Genehmigung, sammeln die erforderlichen Dokumente und vereinbaren
              dann einen passenden Termin für die kostenlose Abholung deines
              Autos.
            </p>
          </li>
          <li>
            <strong>Verkauf abschließen</strong>
            <p>
              In den meisten Fällen erfolgt die Zahlung direkt auf dein
              Bankkonto, bevor dein Fahrzeug den Abholort verlässt. Herzlichen
              Glückwunsch – du hast dein Auto über Autoeinfachlos verkauft!
            </p>
          </li>
        </ul>
      </>
    ),

    metaTitle:
      "Was sind die Schritte beim Verkauf über Autoeinfachlos? – Einfach erklärt",
    metaDescription:
      "Erstelle dein Fahrzeugprofil, erhalte das höchste Angebot von über 5.000 Händlern und verkaufe kostenlos. So funktioniert der Autoverkauf mit Autoeinfachlos",
    link: "/schritte-beim-verkauf",
  },
  {
    id: 5,
    title: "Wie wird mein Fahrzeug dem Händlernetzwerk präsentiert?",
    text: (
      <>
        <p>
          Nachdem du die Fahrzeuginformationen hochgeladen hast, erhältst du
          eine Bewertung. Um mit dem Verkauf fortzufahren, wirst du gebeten,
          dein Fahrzeugprofil zu vervollständigen. Dazu musst du nur noch Fotos
          deines Fahrzeugs hochladen, die von unseren Händlern eingesehen werden
          und auf deren Grundlage sie ihr höchstes Gebot abgeben. Unsere Profile
          sind so gestaltet, dass sie direkt auf die Bedürfnisse unserer Händler
          abgestimmt sind und dein Fahrzeug in der täglichen Auktion bestmöglich
          präsentieren.
        </p>

        <p>
          <strong>Wichtig: </strong>Deine privaten Informationen wie Name,
          Nachname, Fahrgestellnummer, Kennzeichen und alle weiteren Daten, die
          auf dich zurückführen könnten, sind während der Auktion für keinen
          Händler sichtbar. Diese Daten werden erst nach dem Kauf an den
          jeweiligen Händler weitergegeben.
        </p>
      </>
    ),

    metaTitle:
      "Wie wird mein Fahrzeug dem Händlernetzwerk präsentiert? – Autoeinfachlos erklärt",
    metaDescription:
      "Dein Fahrzeugprofil mit Fotos wird verifizierten Händlern gezeigt, anonym und sicher. So erhältst du in der Auktion das beste Gebot für dein Auto",
    link: "/fahrzeug-dem-haendlernetzwerk-praesentieren",
  },
  {
    id: 6,
    title:
      "Kann ich ein Fahrzeug mit Unfallschaden über Autoeinfachlos verkaufen?",
    text: (
      <>
        <p>
          Ja, es ist möglich, dein Auto mit Unfallschaden über Autoeinfachlos zu
          verkaufen. Während du die Fahrzeuginformationen ausfüllst, wirst du
          gebeten, alle Schäden genau zu beschreiben. So können unsere Händler
          eine fundierte Entscheidung treffen und dir ein passendes Angebot
          unterbreiten.
        </p>
      </>
    ),

    metaTitle: "Kann ich ein finanziertes Fahrzeug verkaufen?",
    metaDescription:
      "Ja, auch Autos mit Unfallschaden kannst du über Autoeinfachlos verkaufen. Beschreibe die Schäden im Fahrzeugprofil und erhalte ein passendes Angebot von unseren Händlern",
    link: "/fahrzeug-mit-unfallschaden-verkaufen",
  },
  {
    id: 7,
    title:
      "Kann ich ein Fahrzeug mit Unfallschaden über Autoeinfachlos verkaufen?",
    text: (
      <>
        <p>
          Ja, du kannst dein Fahrzeug auch mit laufender Finanzierung über
          Autoeinfachlos verkaufen. Bereite bis zum Verkaufstermin einfach alle
          Unterlagen deiner Finanzierungsbank. Die ausstehenden Kosten werden
          dann mit dem Verkaufspreis verrechnet, und das Fahrzeug wird bei der
          Bank abgelöst.
        </p>
        <p>
          Falls der offene Finanzierungsbetrag höher ist als der Verkaufspreis,
          musst du die Differenz begleichen – dies kommt jedoch nur selten vor.
          Liegt der offene Finanzierungsbetrag unter dem Verkaufspreis, erhältst
          du die Differenz ausgezahlt.
        </p>
      </>
    ),

    metaTitle:
      "Kann ich ein finanziertes Fahrzeug über Autoeinfachlos verkaufen?",
    metaDescription:
      "Ja, finanziertes Auto verkaufen leicht gemacht. Ausstehende Beträge werden verrechnet, und die Bank wird abgelöst. Erfahre, wie der Prozess funktioniert",
    link: "/finanziertes-fahrzeug-verkaufen",
  },
  {
    id: 8,
    title: "Kann ich ein Fahrzeug ohne Pickerl verkaufen?",
    text: (
      <>
        <p>
          Ja, du kannst dein Fahrzeug auch ohne gültiges Pickerl über
          Autoeinfachlos verkaufen. Beachte jedoch, dass ein fehlendes Pickerl
          den Wert des Fahrzeugs beeinflussen kann, da einige Händler ein
          gültiges Pickerl bevorzugen.
        </p>
      </>
    ),

    metaTitle:
      "Kann ich ein Fahrzeug ohne Pickerl über Autoeinfachlos verkaufen?",
    metaDescription:
      "Ja, auch ohne gültiges Pickerl kannst du dein Fahrzeug über Autoeinfachlos verkaufen. Beachte, dass dies den Fahrzeugwert beeinflussen kann",
    link: "/fahrzeug-ohne-pickerl-verkaufen",
  },
  {
    id: 9,
    title: "Kann ich ein Fahrzeug im Namen einer anderen Person verkaufen?",
    text: (
      <>
        <p>
          Ja. Wenn der eingetragene Halter bei der Abholung des Fahrzeugs
          anwesend ist, um die Übergabe zu unterschreiben, und du lediglich den
          Verkaufsprozess online und telefonisch für ihn übernimmst, sind keine
          zusätzlichen Dokumente erforderlich.
        </p>
        <p>
          Solltest du ein Fahrzeug für jemanden verkaufen, der bei der Abholung
          nicht anwesend sein kann, benötigst du eine unterschriebene Vollmacht
          des eingetragenen Halters sowie eine Kopie seines Führerscheins, um
          die Unterschrift zu bestätigen. Dies gilt auch, wenn du jemand anderen
          – wie einen Freund, Kollegen, Nachbarn oder Verwandten – mit der
          Übergabe des Fahrzeugs am Übergabetag beauftragst.
        </p>
        <p>
          Falls du Fragen hast, kannst du unser
          <a href="/" target="_blank" className="FragenAntworten-link">
            Kundenservice-Team
          </a>
          jederzeit kontaktieren.
        </p>
      </>
    ),

    metaTitle:
      "Kann ich ein Fahrzeug im Namen einer anderen Person verkaufen? – Autoeinfachlos",
    metaDescription:
      "Ja, über Autoeinfachlos kannst du auch ein Fahrzeug für eine andere Person verkaufen. Erfahre, welche Unterlagen benötigt werden und wie es funktioniert",
    link: "/fahrzeug-im-namen-einer-anderen-person-verkaufen",
  },
  {
    id: 10,
    title:
      "Kann ich mein Fahrzeug noch fahren, nachdem ein Verkauf vereinbart wurde?",
    text: (
      <>
        <p>
          Ja. Wir verstehen, dass du dein Fahrzeug möglicherweise noch nutzen
          musst, bevor es abgeholt wird. Autoeinfachlos gewährt dir eine
          Toleranz von 200 Kilometern basierend auf dem Kilometerstand bei der
          ersten Bewertung deines Fahrzeugs. Wenn dein Kilometerstand zum
          Zeitpunkt der Bewertung beispielsweise bei 40.000 Kilometern lag,
          kannst du noch weitere 200 Kilometer fahren, sodass der Gesamtstand
          bei 40.200 Kilometern liegt. Falls du denkst, dass du diese Toleranz
          überschreiten wirst, gib uns bitte während der Profilerstellung
          Bescheid, und wir passen dein Profil an den erwarteten Kilometerstand
          an.
        </p>
      </>
    ),

    metaTitle: "Fahrzeug nach Verkauf noch fahren? – Autoeinfachlos erklärt",
    metaDescription:
      "Ja, du kannst dein Fahrzeug nach dem Verkauf weiterfahren. Autoeinfachlos erlaubt eine Toleranz von 200 Kilometern, basierend auf dem Kilometerstand bei der Bewertung",
    link: "/fahrzeug-noch-fahren-nach-verkauf",
  },
  {
    id: 11,
    title: "Kann ich mein Fahrzeug zur Inspektion vorbeibringen?",
    text: (
      <>
        <p>
          Nein. Bei Autoeinfachlos erfolgt der gesamte Verkauf online, sodass du
          dein Zuhause nicht verlassen musst. Erst nachdem ein Verkauf bestätigt
          wurde, wird sich ein Händler mit dir in Verbindung setzen, um eine
          Inspektion deines Fahrzeugs zu vereinbaren. Sobald der Händler bei der
          Abholung bestätigt hat, dass die Angaben in deinem Fahrzeugprofil
          korrekt sind, wird eine schnelle Zahlung veranlasst, die in der Regel
          innerhalb von 24 Stunden auf deinem Bankkonto eingeht.
        </p>
      </>
    ),

    metaTitle:
      "Kann ich mein Fahrzeug zur Inspektion bringen? – Autoeinfachlos erklärt",
    metaDescription:
      "Nein, bei Autoeinfachlos läuft alles online. Nach dem Verkauf prüft der Händler dein Fahrzeug bei der Abholung und leitet die Zahlung ein",
    link: "/fahrzeug-zur-inspektion-bringen",
  },
  {
    id: 12,
    title: "Kann ich ein importiertes Fahrzeug über Autoeinfachlos verkaufen?",
    text: (
      <>
        <p>
          Ja, du kannst auch ein importiertes Fahrzeug über Autoeinfachlos
          verkaufen. Während der Eingabe der Fahrzeuginformationen hast du die
          Möglichkeit, anzugeben, dass es sich um ein importiertes Fahrzeug
          handelt.
        </p>
      </>
    ),

    metaTitle:
      "Kann ich ein importiertes Fahrzeug verkaufen? – Autoeinfachlos erklärt",
    metaDescription:
      "Ja, auch importierte Fahrzeuge kannst du über Autoeinfachlos verkaufen. Gib einfach an, dass es sich um einen Import handelt, während du die Fahrzeuginformationen eingibst",
    link: "/importiertes-fahrzeug-verkaufen",
  },

  {
    id: 13,
    title: "Kann ich ein modifiziertes Fahrzeug über Autoeinfachlos verkaufen?",
    text: (
      <>
        <p>
          Ja. Allerdings können Modifikationen die Anzahl der Angebote
          beeinflussen, da einige Händler nur standardmäßig ausgestattete
          Fahrzeuge kaufen.
        </p>
        <p>
          Beim Verkauf eines modifizierten Fahrzeugs wirst du gebeten, Dokumente
          bereitzustellen, die bestätigen, dass die Modifikationen fachgerecht
          durchgeführt wurden. Falls du noch über die Originalteile des
          Fahrzeugs verfügst und diese Teil des Verkaufs sein können, erweitert
          dies möglicherweise deine Optionen, da einige Händler das Fahrzeug
          gegebenenfalls in den Originalzustand zurückversetzen möchten.
        </p>
      </>
    ),

    metaTitle:
      "Kann ich ein modifiziertes Fahrzeug verkaufen? – Autoeinfachlos erklärt",
    metaDescription:
      "Ja, du kannst ein modifiziertes Fahrzeug verkaufen. Dokumente zu den Änderungen können helfen, die Anzahl der Angebote zu erhöhen",
    link: "/modifiziertes-fahrzeug-verkaufen",
  },
  {
    id: 14,
    title: "Kann ich ein Schrott- oder nicht fahrbereites Fahrzeug verkaufen?",
    text: (
      <>
        <p>
          Ja, du kannst auch ein Schrott- oder nicht fahrbereites Fahrzeug über
          Autoeinfachlos verkaufen. Wir arbeiten mit einem spezialisierten
          Schrotthändler zusammen, der defekte, stillgelegte oder ältere, nicht
          fahrbereite Fahrzeuge ankauft.
        </p>
      </>
    ),

    metaTitle:
      "Kann ich ein Schrott- oder nicht fahrbereites Fahrzeug verkaufen? – Autoeinfachlos",
    metaDescription:
      "Ja, auch Schrott- und nicht fahrbereite Fahrzeuge kannst du über Autoeinfachlos verkaufen. Wir arbeiten mit spezialisierten Schrotthändlern zusammen",
    link: "/schrottfahrzeug-verkaufen",
  },
];

export const bewertung = [
  {
    id: 1,
    title: "Was ist ein Richtpreis?",
    text: (
      <>
        <p>Wenn du dein Auto profilierst: </p>

        <p>
          Unser Team wird dein Profil prüfen und mit dir einen Richtpreis
          vereinbaren. Das ist der Preis, den wir basierend auf der
          Spezifikation, dem Zustand und der Servicehistorie deines Fahrzeugs
          erwarten.
        </p>

        <p>
          Dein Richtpreis kann niedriger sein als der zunächst geschätzte
          Verkaufspreis, da der Händler, der dein Auto kauft, das Fahrzeug für
          den Wiederverkauf in seinem Autohaus vorbereiten muss und dabei alle
          anfallenden Kosten berücksichtigt, wenn er dir ein Angebot macht.
        </p>

        <p>
          Wenn du dich entscheidest, mit dem Richtpreis fortzufahren, wird dein
          Auto in unserer nächsten verfügbaren Tagesauktion angeboten, die
          normalerweise am folgenden Tag stattfindet, sodass Händler darum
          konkurrieren können, dein Fahrzeug zu kaufen.
        </p>
      </>
    ),
    metaTitle: "Was ist ein Richtpreis? – Autoeinfachlos erklärt",
    metaDescription:
      "Wenn du dein Auto profilierst: Unser Team wird dein Profil prüfen und mit dir einen Richtpreis vereinbaren. Das ist der Preis, den wir basierend auf...",
    link: "/richtpreis",
  },
  {
    id: 2,
    title: "Wie erhalte ich einen geschätzten Verkaufspreis?",
    text: (
      <>
        <p>
          Gib auf der Seite
          <a
            href="/auto-bewerten"
            target="_blank"
            className="FragenAntworten-link"
          >
            Auto bewerten
          </a>
          deine Fahrgestellnummer ein, um sofort einen geschätzten Verkaufspreis
          für dein Fahrzeug zu erhalten. Diese Schätzung basiert auf Daten real
          verkaufter Fahrzeuge auf dem österreichischen Automarkt und
          erfolgreichen Verkäufen auf Autoeinfachlos und ist so präzise wie
          möglich.
        </p>
        <p>
          Unsere Preise werden in Echtzeit aktualisiert, sodass dein geschätzter
          Verkaufspreis auf aktuellen Angeboten für vergleichbare Fahrzeuge
          basiert.
        </p>
        <p>
          Da wir zu diesem Zeitpunkt noch nicht alle Details über dein Auto
          kennen, kann sich der geschätzte Verkaufspreis ändern, sobald wir mehr
          über seine Spezifikationen, seinen Zustand und seine Servicehistorie
          erfahren.
        </p>
      </>
    ),
    metaTitle:
      "Wie erhalte ich einen geschätzten Verkaufspreis? – Autoeinfachlos",
    metaDescription:
      "Gib deine Fahrgestellnummer ein, um sofort einen geschätzten Verkaufspreis zu erhalten. Die Bewertung basiert auf aktuellen Marktdaten des österreichischen Gebrauchtwagenmarkts...",
    link: "/geschaetzten-verkaufspreis-erhalten",
  },
  {
    id: 3,
    title: "Wie viel werde ich bekommen?",
    text: (
      <>
        <p>
          Der Wert jedes Fahrzeugs ist unterschiedlich und hängt von Faktoren
          wie Marke, Modell, Kilometerstand, Alter, Sonderausstattungen und dem
          Zustand ab. Wir bei Autoeinfachlos nutzen aktuelle Marktdaten und
          Branchenkenntnisse, um eine sofortige, realitätsnahe Bewertung
          bereitzustellen.
        </p>
        <p>
          Diese Bewertung basiert auf früheren Angeboten, die Händler für
          ähnliche Fahrzeuge abgegeben haben, sowie auf aktuellen Daten des
          Automobilmarktes. Danach betrachten wir die spezifische Historie,
          Spezifikationen und den Zustand deines Autos, um gemeinsam mit dir
          einen Richtpreis festzulegen, bevor dein Auto in eine unserer
          täglichen Online-Auktionen aufgenommen wird.
        </p>
        <p>
          In unseren täglichen Auktionen nutzen die Händler aktuelle Marktdaten
          für Gebrauchtfahrzeuge sowie ihre eigenen Handelserfahrungen, um ein
          Angebot für dein Fahrzeug abzugeben. Am Ende der Auktion präsentieren
          wir dir das höchste Angebot, das dein Fahrzeug von unserem
          Händlernetzwerk erhalten hat. Es besteht zu keinem Zeitpunkt eine
          Verpflichtung, dein Fahrzeug zu verkaufen.
        </p>
      </>
    ),

    metaTitle: "Wie viel werde ich bekommen? – Autoeinfachlos",
    metaDescription:
      "Der Wert deines Autos hängt von Marke, Zustand und Marktdaten ab. Autoeinfachlos bietet dir das höchste Händlerangebot nach einer präzisen Bewertung",
    link: "/wie-viel-bekomme-ich",
  },
  {
    id: 4,
    title: "Zahlt Autoeinfachlos den Betrag, den sie angeben?",
    text: (
      <>
        <p>
          Mit Autoeinfachlos erhältst du 100 % des besten Angebots, das wir für
          dein Fahrzeug aus unserem landesweiten Netzwerk von geprüften Händlern
          finden. Der Verkauf deines Autos über Autoeinfachlos ist komplett
          kostenlos – es gibt keine Verwaltungsgebühren oder versteckte Kosten.
        </p>
        <p>Der Weg zum endgültigen Verkaufspreis umfasst mehrere Schritte:</p>
        <h3>Starte mit einer Sofortbewertung</h3>
        <p>
          Zuerst bieten wir dir eine realistische Sofortbewertung basierend auf
          aktuellen Marktdaten und den Informationen, die du durch die Eingabe
          deines Fahrgestellnummers und Kilometerstandes auf unserer Website
          bereitstellst. Diesen Preis nennen wir den geschätzten Verkaufspreis,
          basierend auf dem, was wir bisher über dein Fahrzeug wissen.
        </p>
        <h3>Ein Richtpreis wird festgelegt</h3>
        <p>
          Indem du weitere Details zu Spezifikationen, Servicehistorie, Zustand
          und eventuellen Schäden deines Fahrzeugs hinzufügst, stimmen wir mit
          dir einen Richtpreis ab, der auf dein Auto zugeschnitten ist.
        </p>
        <h3>Tägliche Auktion</h3>
        <p>
          Sobald der Richtpreis festgelegt ist, wird dein Fahrzeug in unsere
          tägliche Auktion aufgenommen, und Händler aus unserem landesweiten
          Netzwerk geben Angebote für dein Fahrzeug ab.
        </p>
        <h3>Weiter mit dem besten Angebot</h3>
        <p>
          Du kannst das höchste Angebot, das wir erhalten, annehmen und damit
          fortfahren. Dieses wird dann dein endgültiger Verkaufspreis.
        </p>
        <p>
          Wir setzen alles daran, Fahrzeuge in jeder Phase so genau wie möglich
          zu bewerten, damit das endgültige Angebot deinem Richtpreis
          entspricht. Mehr als die Hälfte der Fahrzeuge, die auf der
          Autoeinfachlos-Plattform verkauft werden, erreichen oder übertreffen
          ihren Richtpreis. Dein endgültiger Verkaufspreis hängt jedoch von der
          Nachfrage der Händler am Tag der Auktion ab.
        </p>
      </>
    ),

    metaTitle:
      "Zahlt Autoeinfachlos den Betrag, den sie angeben? – Autoeinfachlos",
    metaDescription:
      "Mit Autoeinfachlos erhältst du 100 % des besten Angebots, das wir für dein Fahrzeug aus unserem landesweiten Netzwerk von geprüften Händlern finden...",
    link: "/zahlungsbetrag",
  },
  {
    id: 5,
    title:
      "Was kann die Bewertung und den Preis meines Fahrzeugs beeinflussen?",
    text: (
      <>
        <p>
          Wenn du die Daten deines Fahrzeugs auf Autoeinfachlos eingibst,
          erstellen wir eine Bewertung basierend auf grundlegenden Informationen
          wie Marke, Modell, Alter, Sonderausstattung und Kilometerstand des
          Autos, wobei wir annehmen, dass sich das Fahrzeug in ausgezeichnetem
          Zustand befindet.
        </p>

        <p>
          Die wichtigsten Faktoren, die den Wert deines Autos beeinflussen,
          sind:
        </p>
        <h3>Kilometerstand</h3>
        <p>
          Fahrzeuge mit niedrigem Kilometerstand sind in der Regel wertvoller,
          da dies ein guter Indikator dafür ist, wie oft das Auto genutzt wurde
          – und daher auch für den wahrscheinlichen Zustand von Motor, Innenraum
          und Karosserie. Der durchschnittliche Autofahrer in Österreich fährt
          pro Jahr zwischen 8.000 und 15.000 Meilen für Arbeit und Freizeit.
        </p>
        <h3>Zustand</h3>
        <p>
          Der Straßenverkehr in Österreich führt oft dazu, dass Autos im Laufe
          der Zeit Steinschläge, Dellen und Kratzer aufweisen. Parkplätze und
          hohe Bordsteine können ebenfalls Beschädigungen verursachen,
          insbesondere an den Felgen. Wenn du den Zustand deines Autos bei der
          Profilierung genau angibst, können wir einen genauen Richtpreis
          festlegen und das Risiko von Problemen bei der Abholung deines Autos
          reduzieren. Autoeinfachlos hilft dir, den Zustand deines Autos mit
          einem Online-Formular und einer benutzerfreundlichen Fotofunktion zu
          erfassen.
        </p>
        <h3>Servicehistorie</h3>
        <p>
          Fahrzeuge, bei denen alle Servicearbeiten gemäß den vorgegebenen
          Wartungsintervallen des Herstellers durchgeführt wurden, sind
          wertvoller, da sie von einem qualifizierten Mechaniker oder Techniker
          geprüft und gewartet wurden. Wenn deine Servicehistorie vollständig
          und aktuell ist, kann ein Händler davon ausgehen, dass das Auto von
          guter Qualität und fahrbereit ist. Der Wert eines Autos mit
          vollständiger Servicehistorie wird höher sein als bei demselben Modell
          mit einer unvollständigen oder fehlenden Servicehistorie.
        </p>
        <h3>Anzahl der Vorbesitzer</h3>
        <p>
          Je weniger Vorbesitzer dein Auto hatte, desto besser für die
          Bewertung. Wenn du der einzige Vorbesitzer warst, ist das ideal, aber
          es ist nicht ungewöhnlich, dass ein Auto mehrere Vorbesitzer hatte.
          Wir finden Händlerangebote unabhängig von der Anzahl der Vorbesitzer.
        </p>
        <h3>Farbe des Fahrzeugs</h3>
        <p>
          Die Farbe kann eine kleine Rolle bei der Bewertung spielen, da einige
          Farben begehrter sind als andere – und dies kann sich in der Anzahl
          der Angebote widerspiegeln, die du für dein Fahrzeug erhältst.
          Neutrale oder Standardfarben wie Blau, Grau oder Schwarz sind auf dem
          Gebrauchtwagenmarkt beliebt – pinke oder orangefarbene Fahrzeuge sind
          weniger gefragt.
        </p>
        <h3>Unfallschäden</h3>
        <p>
          Wenn dein Fahrzeug in einen Unfall verwickelt war, beeinflusst das den
          Wert, selbst wenn es repariert wurde. Unfallfahrzeuge sind oft weniger
          wert als unfallfreie Fahrzeuge, da viele Käufer unfallfreie Autos
          bevorzugen. Auch in diesen Fällen finden wir den besten Käufer für
          dich, um das beste Angebot herauszuholen.
        </p>
        <p>
          Unser
          <a href="/" target="_blank" className="FragenAntworten-link">
            Kundenservice-Team
          </a>
          steht dir jederzeit zur Verfügung.
        </p>
      </>
    ),

    metaTitle:
      "Was beeinflusst die Bewertung und den Preis meines Autos? – Autoeinfachlos",
    metaDescription:
      "Kilometerstand, Zustand, Servicehistorie, Farbe und weitere Faktoren beeinflussen den Wert deines Autos. Erfahre, wie wir bei Autoeinfachlos eine präzise Bewertung erstellen...",
    link: "/bewertung-und-preis-faktoren",
  },
  {
    id: 6,
    title:
      "Was ist der Unterschied zwischen dem geschätzten Verkaufspreis und dem Richtpreis?",
    text: (
      <>
        <p>
          Der Weg zum endgültigen Verkaufspreis deines Fahrzeugs umfasst mehrere
          Schritte:
        </p>
        <h3>Starte mit einer Sofortbewertung</h3>
        <p>
          Zuerst bietet Autoeinfachlos eine realistische Sofortbewertung
          basierend auf aktuellen Marktdaten und den Informationen, die du durch
          Eingabe deines Kennzeichens und Kilometerstandes auf der Webseite
          bereitstellst. Den Preis, den wir in dieser Phase nennen, bezeichnen
          wir als geschätzten Verkaufspreis, basierend auf den Daten, die wir
          bisher über dein Auto haben.
        </p>
        <h3>Festlegung eines Richtpreises</h3>
        <p>
          Durch Hinzufügen weiterer Details wie Spezifikation, Servicehistorie,
          Zustand und eventuelle Schäden deines Fahrzeugs stimmen wir mit dir
          einen Richtpreis ab, der auf dein Auto zugeschnitten ist.
        </p>
        <h3>Tägliche Auktion</h3>
        <p>
          Sobald der Richtpreis festgelegt ist, wird dein Auto in unsere
          tägliche Auktion aufgenommen, und Händler aus unserem landesweiten
          Netzwerk geben Angebote für dein Fahrzeug ab.
        </p>
        <h3>Weiter mit dem besten Angebot</h3>
        <p>
          Du kannst das höchste Angebot, das wir erhalten, annehmen und damit
          fortfahren. Dieses wird dann dein endgültiger Verkaufspreis.
        </p>
        <p>
          Wir setzen alles daran, den Preis für Fahrzeuge in jeder Phase so
          genau wie möglich zu bestimmen, damit der endgültige Verkaufspreis
          deinem Richtpreis entspricht. In manchen Fällen übersteigt das beste
          Angebot aus unserem Netzwerk sogar deinen Richtpreis, und du kannst
          diesen höheren Betrag annehmen. Dein endgültiger Verkaufspreis hängt
          jedoch von der Händlernachfrage am Auktionstag ab.
        </p>
      </>
    ),

    metaTitle:
      "Unterschied zwischen geschätztem Verkaufspreis und Richtpreis – Autoeinfachlos",
    metaDescription:
      "Der geschätzte Verkaufspreis basiert auf Marktdaten, während der Richtpreis auf Spezifikationen und Zustand deines Autos abgestimmt wird. Erfahre mehr...",
    link: "/geschaetzter-verkaufspreis-vs-richtpreis",
  },
  {
    id: 7,
    title: "Was passiert, wenn der Richtpreis nicht erreicht wird?",
    text: (
      <>
        <p>
          Wenn dein Fahrzeug den vereinbarten Richtpreis nicht erreicht, senden
          wir dir dennoch das beste Angebot, das dein Fahrzeug während der
          Auktion erhalten hat, und du kannst entscheiden, wie du weiter
          verfahren möchtest.
        </p>
      </>
    ),

    metaTitle:
      "Was passiert, wenn der Richtpreis nicht erreicht wird? – Autoeinfachlos",
    metaDescription:
      "Wenn der Richtpreis nicht erreicht wird, erhältst du das höchste Gebot aus der Auktion und kannst entscheiden, ob du das Angebot annimmst",
    link: "/richtpreis-nicht-erreicht",
  },
  {
    id: 8,
    title:
      "Warum hat sich mein geschätzter Verkaufspreis seit der letzten Überprüfung geändert?",
    text: (
      <>
        <p>
          Die Bewertungen auf unserer Website werden in Echtzeit berechnet und
          können sich daher täglich ändern.
        </p>
        <p>
          Unsere Verkaufspreisschätzungen basieren auf Branchenrichtwerten,
          aktuellen Marktdaten und unseren eigenen Verkaufszahlen – das
          bedeutet, dass dein Preis steigen oder fallen kann, abhängig davon,
          wie vergleichbare Fahrzeuge aktuell verkauft werden.
        </p>
      </>
    ),

    metaTitle:
      "Warum hat sich mein geschätzter Verkaufspreis geändert? – Autoeinfachlos",
    metaDescription:
      "Dein geschätzter Verkaufspreis basiert auf Echtzeit-Marktdaten. Änderungen entstehen durch aktuelle Verkaufszahlen und die Nachfrage nach ähnlichen Fahrzeugen",
    link: "/verkaufspreis-geaendert",
  },
  {
    id: 9,
    title:
      "Mein Fahrzeug ist bald zur Wartung fällig. Beeinflusst das den Preis?",
    text: (
      <>
        <p>
          Wenn der Händler, der dein Fahrzeug kauft, für eine fällige oder
          überfällige Wartung zahlen muss, um es weiterzuverkaufen, werden die
          Servicekosten in der Regel von den Angeboten abgezogen, die du
          erhältst. Wenn jedoch die Servicehistorie deines Fahrzeugs
          unvollständig ist, kann dies den Wiederverkaufswert stärker
          beeinträchtigen.
        </p>
      </>
    ),

    metaTitle:
      "Beeinflusst eine fällige Wartung den Preis meines Autos? – Autoeinfachlos",
    metaDescription:
      "Ja, eine fällige Wartung kann den Preis beeinflussen. Händler ziehen oft Servicekosten ab, wenn das Fahrzeug gewartet werden muss",
    link: "/wartung-preis-beeinflussen",
  },
];

export const fahrzeugInformationUndFahrzeugprofil = [
  {
    id: 1,
    title: "Wie wird ein Fahrzeugprofil erstellt?",
    text: (
      <>
        <p>
          Dein Fahrzeugprofil wird automatisch erstellt, sobald du die
          Fahrzeugdetails eingibst oder eine Fahrzeugbewertung durchführst. Über
          dein Fahrzeugprofil kannst du jederzeit den aktuellen Wert deines
          Fahrzeugs abrufen, wichtige Details einsehen und dein Fahrzeug mit nur
          einem Klick an unsere Händler verkaufen.
        </p>
      </>
    ),
    metaTitle: "Wie wird ein Fahrzeugprofil erstellt? – Autoeinfachlos erklärt",
    metaDescription:
      "Dein Fahrzeugprofil wird automatisch erstellt, wenn du deine Fahrzeugdetails eingibst. Es zeigt den Wert, Details und ermöglicht den Verkauf mit nur einem Klick",
    link: "/fahrzeugprofil-erstellen",
  },
  {
    id: 2,
    title: "Wie gebe ich die Details meines Autos an?",
    text: (
      <>
        <p>
          Die Profilierung deines Autos ist ganz einfach und kann in wenigen
          Minuten per Handy erledigt werden.
        </p>
        <p>
          Unser einfacher Prozess ermöglicht es dir, Details zum Fahrzeug
          anzugeben, wie seinen Zustand, die Servicehistorie und eventuelle
          Schäden. Dieser Schritt hilft uns, den bestmöglichen Preis für dich zu
          finden!
        </p>
        <p>
          Du wirst außerdem gebeten, genaue Fotos deines Autos zu machen,
          ähnlich wie beim Online-Verkauf von anderen Dingen. Wir machen es dir
          ganz leicht, Fotos mit deinem Handy aufzunehmen, und führen dich durch
          die verschiedenen Winkel, die wir benötigen.
        </p>

        <p>
          Falls du Unterstützung beim Fotografieren benötigst, steht dir unser
          <a
            href="/kontaktiere-uns"
            target="_blank"
            className="FragenAntworten-link"
          >
            Verkaufsteam
          </a>
          jederzeit zur Verfügung, um dir zu helfen.
        </p>
      </>
    ),
    metaTitle: "Wie gebe ich die Details meines Autos an? – Autoeinfachlos",
    metaDescription:
      "Gib die Details deines Autos schnell und einfach per Handy mit wenigen Klicks ein. Ergänze Zustand, Servicehistorie und Fotos, um den besten Preis zu erzielen",
    link: "/fahrzeugdetails-angeben",
  },
  {
    id: 3,
    title: "Warum muss ich Fotos von meinem Fahrzeug machen?",
    text: (
      <>
        <p>
          Hochwertige Fotos sind entscheidend, um den bestmöglichen Preis von
          unseren Händlern zu erhalten. Sie ermöglichen es, den Zustand des
          Fahrzeugs sowie eventuelle Mängel oder Unvollkommenheiten zu sehen.
          Alle Angebote, die wir sichern, basieren vollständig auf den
          bereitgestellten Fotos und Informationen. Da wir den Preis anhand der
          Fotos berechnen, muss der Händler das Fahrzeug in voller Ansicht
          sehen, um sein bestes Angebot abgeben zu können. Genaue Fotos des
          gesamten Fahrzeugs erhöhen die Nachfrage, machen es für Händler
          attraktiver und helfen, Probleme bei der Abholung zu vermeiden.
        </p>
        <p>
          Keine Sorge, der gesamte Prozess ist sehr benutzerfreundlich und zeigt
          dir genau, wie die Fotos und Blickwinkel aussehen müssen, damit wir
          dir den bestmöglichen Preis sichern können.
        </p>
      </>
    ),

    metaTitle:
      "Warum muss ich Fotos von meinem Fahrzeug machen? – Autoeinfachlos",
    metaDescription:
      "Fotos deines Autos zeigen Zustand und Details, die Händler für Angebote benötigen. Hochwertige Bilder helfen, den besten Preis zu sichern und Probleme zu vermeiden",
    link: "/fotos-fahrzeug-machen",
  },
  {
    id: 4,
    title: "Wie viele Fotos muss ich bereitstellen?",
    text: (
      <>
        <p>
          Um dein Auto zum Verkauf anzubieten, benötigen wir 16 Fotos deines
          Fahrzeugs. Diese umfassen die Außenansicht, den Innenraum, die Räder
          und das Reifenprofil sowie Fotos von eventuellen Mängeln. Wenn du den
          Anweisungen folgst, den wir dir zur Verfügung stellen, wirst du durch
          die erforderlichen Aufnahmen geführt, sodass wir hochwertige Fotos in
          bester Qualität erhalten.
        </p>
        <p>
          Die Auswahl der Fotos basiert auf umfangreicher Beratung mit vielen
          Händlern. Sie geben einen umfassenden Überblick über dein Fahrzeug und
          ermöglichen es den Händlern, mit Vertrauen ein Angebot abzugeben.
          Hochwertige Fotos helfen, das Angebot für dein Auto zu maximieren.
        </p>

        <p>
          Bitte beachte: Wir können keine Fotos von Drittanbieter-Websites wie
          AutoScout24 oder eBay akzeptieren.
        </p>
      </>
    ),

    metaTitle:
      "Wie viele Fotos muss ich bereitstellen? – Autoeinfachlos erklärt",
    metaDescription:
      "Für den Verkauf deines Autos benötigen wir 16 Fotos, die Außenansicht, Innenraum und Mängel zeigen. Hochwertige Bilder maximieren das Händlerangebot",
    link: "/anzahl-fotos-fahrzeug",
  },
  {
    id: 5,
    title: "Wie mache und sende ich die Fotos, die ihr benötigt?",
    text: (
      <>
        <p>
          Du kannst die Fotos einfach mit jedem Smartphone aufnehmen, indem du
          den Anweisungen folgst, den wir dir zur Verfügung stellen.
        </p>
        <p>
          Auf dem Bildschirm werden dir Anweisungen und Hilfestellungen
          angezeigt, damit du schnell und unkompliziert alle erforderlichen
          Aufnahmen machen kannst.
        </p>
        <p>Hier ist unsere Checkliste zur Vorbereitung deiner Fotos:</p>
        <ul className="gepunktete-antwort">
          <li>
            Wähle einen trockenen Tag und plane, die Fotos bei Tageslicht zu
            machen.
          </li>
          <li>
            Achte darauf, dass dein Fahrzeug sauber ist – innen und außen.
          </li>
          <li>
            Entferne alle persönlichen Gegenstände, wie Kindersitze,
            Einkaufstaschen, Essensreste oder Mitfahrer!
          </li>
          <li>
            Parke an einem Ort, an dem du genügend Platz hast, um das Fahrzeug
            rundherum abzulichten.
          </li>
        </ul>
        <p>
          Um deine Fotos besonders gut wirken zu lassen und den Wert deines
          Autos zu maximieren, empfehlen wir:
        </p>

        <ul className="gepunktete-antwort">
          <li>
            Eine professionelle Reinigung deines Fahrzeugs in einer Waschanlage.
          </li>
          <li>
            Die Fotos an einem bewölkten Tag zu machen, um Blendung und
            Reflexionen zu minimieren.
          </li>
          <li>
            Einen Ort zu wählen, wie z. B. einen ruhigen Parkplatz, wo genügend
            Platz ist, um Abstand zu halten und dein Fahrzeug optimal zu
            fotografieren.
          </li>
        </ul>
      </>
    ),

    metaTitle:
      "Wie mache und sende ich die Fotos meines Autos? – Autoeinfachlos erklärt",
    metaDescription:
      "Du kannst die Fotos einfach mit jedem Smartphone aufnehmen, indem du den Anweisungen folgst, den wir dir zur Verfügung stellen. So maximierst du den Wert deines Autos",
    link: "/fotos-machen-und-senden",
  },
  {
    id: 6,
    title:
      "Ich habe bereits Fotos von meinem Fahrzeug, kann ich diese verwenden?",
    text: (
      <>
        <p>
          Leider nicht. Wir bitten dich, die Anweisungen zu nutzen, den wir zur
          Verfügung stellen, um eine standardisierte Serie von Fotos deines
          Fahrzeugs aufzunehmen. Die Auswahl der Fotos basiert auf umfangreicher
          Beratung mit vielen Händlern. Diese Bilder bieten einen umfassenden
          Überblick über dein Fahrzeug und ermöglichen es jedem Händler, mit
          Vertrauen ein Angebot abzugeben.
        </p>
      </>
    ),

    metaTitle:
      "Kann ich bereits vorhandene Fotos meines Fahrzeugs verwenden? – Autoeinfachlos",
    metaDescription:
      "Leider können vorhandene Fotos nicht verwendet werden. Folge unseren Anweisungen, um eine standardisierte Fotoserie aufzunehmen, die Händler überzeugt",
    link: "/vorhandene-fotos-verwenden",
  },
  {
    id: 7,
    title: "Muss ich Gebrauchsspuren angeben?",
    text: (
      <>
        <p>
          Ja. Unsere Händler stützen ihre Angebote auf die Angaben in deinem
          Fahrzeugprofil. Deshalb ist es wichtig, alle Gebrauchsspuren, auch
          wenn sie nur oberflächlich sind, offenzulegen. Wenn dein Fahrzeug
          Mängel aufweist, die vor dem Verkauf nicht angegeben wurden, kann dies
          zu einem reduzierten Angebot des Händlers oder sogar zur Stornierung
          führen.
        </p>
      </>
    ),

    metaTitle: "Muss ich Gebrauchsspuren angeben? – Autoeinfachlos erklärt",
    metaDescription:
      "Ja, Gebrauchsspuren sollten angegeben werden. Sie helfen Händlern, präzise Angebote zu erstellen und vermeiden Probleme beim Verkauf deines Fahrzeugs",
    link: "/gebrauchsspuren-angeben",
  },
  {
    id: 8,
    title: "Muss ich Steinschläge an meinem Fahrzeug angeben?",
    text: (
      <>
        <p>
          Ja. Unsere Händler stützen ihre Angebote auf die Angaben im
          Fahrzeugprofil. Daher müssen alle Mängel, auch wenn sie nur
          oberflächlich sind, angegeben werden. Wenn Schäden vor dem Verkauf
          nicht offengelegt werden, kann dies zu einem reduzierten Angebot des
          Händlers oder sogar zur Stornierung führen.
        </p>
      </>
    ),

    metaTitle:
      "Muss ich Steinschläge an meinem Fahrzeug angeben? – Autoeinfachlos",
    metaDescription:
      "Ja, Steinschläge sollten angegeben werden. Unvollständige Angaben können zu einem reduzierten Händlerangebot oder einer Stornierung führen",
    link: "/steinschlaege-angeben",
  },
  {
    id: 9,
    title:
      "Ich habe nach der Profilerstellung zusätzlichen Schaden an meinem Fahrzeug entdeckt. Was sollte ich tun?",
    text: (
      <>
        <p>
          Wenn dein Fahrzeugprofil nicht mehr korrekt ist, müssen wir es
          aktualisieren und dir möglicherweise einen neuen Mindest- oder
          geschätzten Verkaufspreis anbieten. Wenn du uns über Änderungen am
          Zustand deines Fahrzeugs nicht informierst, kann dies zu einem
          reduzierten Angebot führen, wenn der Händler dein Fahrzeug abholt,
          oder der Verkauf könnte storniert werden.
        </p>
      </>
    ),

    metaTitle:
      "Was tun bei zusätzlichem Schaden nach der Profilerstellung? – Autoeinfachlos",
    metaDescription:
      "Informiere uns über zusätzlichen Schaden nach der Profilerstellung, damit dein Fahrzeugprofil aktualisiert wird und es nicht zu Problemen beim Verkauf kommt",
    link: "/zusaetzlicher-schaden-nach-profilerstellung",
  },
  {
    id: 10,
    title: "Was ist die Servicehistorie meines Fahrzeugs?",
    text: (
      <>
        <p>
          Die Servicehistorie deines Fahrzeugs ist eine Aufzeichnung aller
          Wartungsarbeiten, die während seiner Lebensdauer durchgeführt wurden.
          Eine vollständige Servicehistorie gibt Händlern ein umfassendes Bild
          über die Pflege und den Gesamtzustand des Fahrzeugs. Der Wert eines
          Autos mit vollständiger Servicehistorie ist höher als bei einem
          identischen Fahrzeug mit unvollständiger oder fehlender
          Servicehistorie.
        </p>
      </>
    ),

    metaTitle: "Was ist die Servicehistorie meines Fahrzeugs? – Autoeinfachlos",
    metaDescription:
      "Die Servicehistorie zeigt alle durchgeführten Wartungen deines Autos. Eine vollständige Historie erhöht den Fahrzeugwert und gibt Händlern Vertrauen beim Kauf",
    link: "/servicehistorie-fahrzeug",
  },
  {
    id: 11,
    title: "Woher bekomme ich die Servicehistorie meines Fahrzeugs?",
    text: (
      <>
        <p>
          In der Regel findest du die Servicehistorie in deinem Serviceheft
          oder, bei neueren Modellen, online auf der Website des Herstellers
          oder Händlers. Falls du keinen Zugang dazu hast, gibt es weitere
          Möglichkeiten, an die Servicehistorie zu gelangen.
        </p>
        <p>
          Bei einigen Fahrzeugen kannst du die Servicehistorie direkt im Menü
          des Fahrzeugdisplays einsehen, falls dein Modell diese Option
          unterstützt. Außerdem bieten manche Hersteller die Möglichkeit, die
          Servicehistorie online abzurufen.
        </p>
        <p>
          Alternativ kannst du den Hersteller direkt kontaktieren, um
          herauszufinden, wie viele Serviceleistungen bei Vertragswerkstätten
          durchgeführt wurden. Einige Hersteller können dir auch Informationen
          über Serviceleistungen bei freien Werkstätten geben.
        </p>
        <p>
          Falls dein Fahrzeug in unabhängigen Werkstätten gewartet wurde, können
          Kopien der Service-Rechnungen oft auch dort angefragt werden, da
          Werkstätten gesetzlich verpflichtet sind, diese Aufzeichnungen sieben
          Jahre lang aufzubewahren.
        </p>
      </>
    ),

    metaTitle:
      "Woher bekomme ich die Servicehistorie meines Fahrzeugs? – Autoeinfachlos",
    metaDescription:
      "In der Regel findest du die Servicehistorie in deinem Serviceheft oder, bei neueren Modellen, online auf der Website des Herstellers oder Händlers",
    link: "/servicehistorie-beschaffen",
  },
  {
    id: 12,
    title:
      "Muss ich Details zu allen Serviceleistungen meines Fahrzeugs angeben oder nur zur letzten?",
    text: (
      <>
        <p>
          Du solltest möglichst viele Details zur Servicehistorie deines
          Fahrzeugs angeben, idealerweise mit Fotos aller vorhandenen
          Servicenachweise. Die Servicehistorie ist einer der wichtigsten
          Faktoren, die Händler zur Bewertung deines Fahrzeugs heranziehen, und
          eine vollständige Servicehistorie wirkt sich in der Regel positiv auf
          den Verkaufspreis deines Fahrzeugs aus.
        </p>
      </>
    ),

    metaTitle:
      "Muss ich alle Serviceleistungen meines Fahrzeugs angeben? – Autoeinfachlos",
    metaDescription:
      "Eine vollständige Servicehistorie erhöht den Wert deines Autos. Gib möglichst alle Details an, inklusive Fotos der Servicenachweise, für die beste Bewertung",
    link: "/serviceleistungen-angeben",
  },
  {
    id: 13,
    title:
      "Mir wurde mitgeteilt, dass meine Reifen Risse oder Spalten aufweisen. Was bedeutet das?",
    text: (
      <>
        <p>
          Das bedeutet, dass deine Reifen zwischen den Profilrillen oder entlang
          der Seitenwand beschädigt sind. Schwankende Wetterbedingungen sind
          häufig die Ursache, da sich Reifen bei Hitze und Kälte ausdehnen und
          zusammenziehen. Im Laufe der Zeit kann dies die Reifenstruktur
          schwächen, was zu Rissen im Material führt. Solche Risse oder Spalten
          werden in der Regel bei der §57a-Begutachtung (Pickerl) festgestellt.
          Sobald ein Reifen Risse aufweist, muss er ersetzt werden, da sich sein
          Zustand nur weiter verschlechtern und potenziell gefährlich werden
          kann. Dies könnte zu einer Preisreduzierung führen, um die Kosten für
          den Reifenersatz zu decken.
        </p>
      </>
    ),

    metaTitle:
      "Was bedeuten Risse oder Spalten in meinen Reifen? – Autoeinfachlos erklärt",
    metaDescription:
      "Risse oder Spalten entstehen durch Materialermüdung und Wetterbedingungen. Solche Schäden erfordern einen Ersatz und können den Fahrzeugpreis beeinflussen",
    link: "/reifen-risse-spalten-bedeutung",
  },
  {
    id: 14,
    title: "Wie ändere ich den Kilometerstand im Profil meines Fahrzeugs?",
    text: (
      <>
        <p>
          Falls du den Kilometerstand nicht selbst über unsere Website ändern
          kannst, wird dein Fahrzeug möglicherweise bereits überprüft. In diesem
          Fall wende dich bitte an unser
          <a href="/" target="_blank" className="FragenAntworten-link">
            Kundenservice-Team.
          </a>
        </p>

        <p>
          Wenn dein Fahrzeug bereits in einer unserer täglichen Online-Auktionen
          ist, solltest du unser
          <a href="/" target="_blank" className="FragenAntworten-link">
            Kundenservice-Team.
          </a>
          kontaktieren. Dieses Team kann dann potenzielle Käufer, die bereits
          ein Gebot auf dein Fahrzeug abgegeben haben, informieren, damit sie
          ihre Angebote entsprechend anpassen oder zurückziehen können.
        </p>
      </>
    ),

    metaTitle:
      "Wie ändere ich den Kilometerstand im Fahrzeugprofil? – Autoeinfachlos",
    metaDescription:
      "Kontaktiere unser Kundenservice-Team, um den Kilometerstand zu ändern, insbesondere wenn dein Fahrzeug bereits in einer Online-Auktion ist",
    link: "/kilometerstand-aendern",
  },
];

export const dokumente = [
  {
    id: 1,
    title:
      "Welche Dokumente benötige ich, um mein Fahrzeug bei Autoeinfachlos zu verkaufen?",
    text: (
      <>
        <p>
          Um dein Fahrzeug bei Autoeinfachlos zu verkaufen, musst du eine
          Auswahl an Dokumenten bereitstellen, um sicherzustellen, dass der
          Verkauf legal ist und deine Identität bestätigt wird.
        </p>

        <h2>Beim Erstellen des Fahrzeugprofils</h2>
        <ul className="gepunktete-antwort">
          <li>
            <h3>Servicehistorie</h3>
            <p>
              Beim Profilieren deines Fahrzeugs wirst du aufgefordert, Bilder
              deiner Servicehistorie-Dokumente hochzuladen. Diese Dokumente
              helfen uns, einen passenden Richtpreis zu berechnen, der den
              Zustand und die Qualität deines Fahrzeugs widerspiegelt. Die
              Servicehistorie zeigt alle Wartungsarbeiten, die während der
              Lebensdauer deines Fahrzeugs durchgeführt wurden. Eine
              vollständige Servicehistorie gibt den Händlern ein umfassendes
              Bild von der Pflege und dem Gesamtzustand des Fahrzeugs.
            </p>
          </li>
        </ul>
        <h2>Während der täglichen Online-Auktion</h2>
        <p>
          Sobald sich dein Fahrzeug in der Auktion befindet, benötigen wir die
          folgenden Dokumente. Du kannst Kopien als Fotos mit deiner Kamera oder
          einem Scanner hochladen. Wir teilen dir mit, ob die Bildqualität
          ausreichend ist. Falls nicht, bitten wir dich, die Dokumente erneut
          hochzuladen.
        </p>
        <ul className="gepunktete-antwort">
          <li>
            <h3>Führerschein</h3>
            <p>
              Wir benötigen einen gültigen Führerschein – abgelaufene Dokumente
              werden nicht akzeptiert. Lade nur ein Foto der Vorderseite des
              Dokuments hoch.
            </p>
          </li>
          <li>
            <h3>Bankdaten</h3>
            <p>
              Diese Daten teilen wir erst nach Bestätigung des Verkaufs mit dem
              Händler, sodass eine schnelle Zahlung gewährleistet ist.
            </p>
          </li>
          <li>
            <h3>
              Finanzierungsbestätigung – falls das Fahrzeug finanziert ist
            </h3>
            <p>
              Beachte, dass diese Dokumente nur für einen begrenzten Zeitraum
              gültig sind und dass der angegebene Wert mindestens zehn Tage ab
              dem Hochladedatum gültig sein muss.
            </p>
          </li>
        </ul>
        <p>
          Für weitere Informationen siehe unseren FAQ „Wie verkaufe ich ein
          finanziertes Fahrzeug bei Autoeinfachlos?“
        </p>
        <h2>Bring zu deinem Abgabe-Termin folgende Dinge mit</h2>
        <ul className="gepunktete-antwort">
          <li>
            <p>Zulassungsbescheinigung Teil 1</p>
          </li>
          <li>
            <p>Zulassungsbescheinigung Teil 2</p>
          </li>
          <li>
            <p>alle noch vorhandenen Fahrzeugschlüssel</p>
          </li>
          <li>
            <p>deinen gültigen Personalausweis oder Reisepass</p>
          </li>
        </ul>
        <h3>Falls vorhanden, bringst du bitte auch folgenden Dinge mit:</h3>
        <ul className="gepunktete-antwort">
          <li>
            <p>zugehöriges Service-Heft</p>
          </li>
          <li>
            <p>Das letzte §57a-Gutachten</p>
          </li>
          <li>
            <p>
              vorhandene Rechnungen und Belege (Neuwagenkauf, Service,
              Reparaturen etc.)
            </p>
          </li>
          <li>
            <p>EU-Übereinstimmungsbescheinigung (sofern vorhanden)</p>
          </li>
          <li>
            <p>zweiten Satz Räder (sofern vorhanden)</p>
          </li>
        </ul>
        <h2>
          Falls du im Namen des eingetragenen Halters und/oder Eigentümers
          verkaufst
        </h2>
        <p>
          Siehe unsere FAQ „Kann ich das Auto einer anderen Person bei
          Autoeinfachlos verkaufen?
        </p>
        <p>
          Falls du Fragen hast, kannst du unser
          <a href="/" target="_blank" className="FragenAntworten-link">
            Kundenservice-Team
          </a>
          jederzeit kontaktieren.
        </p>
      </>
    ),
    metaTitle:
      "Welche Dokumente benötige ich, um mein Fahrzeug zu verkaufen? – Autoeinfachlos",
    metaDescription:
      "Führerschein, Zulassungsbescheinigung und Servicehistorie: Erfahre, welche Dokumente du für den Verkauf über Autoeinfachlos bereithalten musst",
    link: "/fahrzeugverkauf-dokumente",
  },
  {
    id: 2,
    title: "Wie verkaufe ich mein finanziertes Auto bei Autoeinfachlos?",
    text: (
      <>
        <p>
          Es ist kostenlos und einfach, dein finanziertes Auto bei
          Autoeinfachlos zu verkaufen. Die Händler im Netzwerk von
          Autoeinfachlos begleichen deine Finanzierung direkt mit dem
          Kreditgeber, indem sie den Erlös aus deinem Verkauf verwenden.
        </p>
        <p>So funktioniert es:</p>
        <ul className="nummerierte-antwort">
          <li>
            <h3>Erhalte eine kostenlose Sofortbewertung</h3>
            <p>
              Erhalte eine Sofortbewertung bei Autoeinfachlos, um den aktuellen
              Wert deines Autos zu erfahren.
            </p>
          </li>
          <li>
            <h3>
              Fordere eine Ablösebestätigung von deiner Finanzierungsbank an.
            </h3>
            <p>
              Falls du den Verkauf in Betracht ziehst, kontaktiere dein
              Finanzierungsunternehmen und bitte um eine „Ablösebestätigung“.
              Dieses Schreiben muss den gesamten zu zahlenden Betrag, die
              Bankverbindung des Kreditgebers und die Vertragsreferenznummer
              enthalten.
            </p>
            <ul className="gepunktete-antwort">
              <li>
                <p>
                  Die im Schreiben angegebene Summe ist nur für kurze Zeit
                  gültig – normalerweise 10 Tage.
                </p>
              </li>
              <li>
                <p>
                  Überprüfe auch deinen Vertrag, um festzustellen, ob
                  zusätzliche Gebühren anfallen, falls du die Finanzierung
                  vorzeitig ablöst.
                </p>
              </li>
            </ul>
          </li>
          <li>
            <h3>Verkauf und Ablösung der Finanzierung</h3>
            <p>
              Wenn du dein Auto bei Autoeinfachlos an einen geprüften Händler
              verkaufst, wird dieser die verbleibende Finanzierung mit dem
              Verkaufserlös begleichen. Beachte, dass es bis zu 10 Tage dauern
              kann, bis dein Kreditgeber die Ablösung der Finanzierung
              registriert. Ein eventuell überschüssiger Betrag wird dir schnell
              zurückerstattet.
            </p>
          </li>
        </ul>
        <h2>
          Was passiert, wenn der Verkaufspreis und der Finanzierungsbetrag
          unterschiedlich sind?
        </h2>
        <ul className="gepunktete-antwort">
          <li>
            <h3>Positives Eigenkapital:</h3>
            <p>
              Wenn dein Verkaufserlös den verbleibenden Finanzierungsbetrag
              übersteigt, befindest du dich im positiven Eigenkapital. Der
              Händler begleicht die Finanzierung und zahlt dir den Überschuss.
            </p>
          </li>
          <li>
            <h3>Negatives Eigenkapital:</h3>
            <p>
              Wenn der Verkaufspreis niedriger ist als der Finanzierungsbetrag,
              befindest du dich im negativen Eigenkapital. Du kannst dein
              finanziertes Fahrzeug dennoch verkaufen (vorbehaltlich der
              Vertragsbedingungen) – du musst lediglich die Differenz
              ausgleichen, bevor der Händler den Gesamtbetrag an den Kreditgeber
              überweist.
            </p>
          </li>
        </ul>
      </>
    ),
    metaTitle:
      "Wie verkaufe ich mein finanziertes Auto? – Autoeinfachlos erklärt",
    metaDescription:
      "Verkaufe dein finanziertes Auto einfach und kostenlos über Autoeinfachlos. Händler begleichen die Finanzierung direkt, und du erhältst den Überschuss schnell zurück",
    link: "/finanziertes-auto-verkaufen",
  },
  {
    id: 3,
    title: "Wie wird der Kaufvertrag bei Autoeinfachlos gestaltet?",
    text: (
      <>
        <p>
          In Österreich erfolgt die Eigentumsübertragung bei einem
          Fahrzeugverkauf üblicherweise durch einen Kaufvertrag. Wenn du dein
          Fahrzeug über Autoeinfachlos an einen Händler verkaufst, bringt der
          Händler einen vorgefertigten Kaufvertrag mit, in dem der Ausschluss
          der Gewährleistung klar geregelt ist. Dieser Gewährleistungsausschluss
          schützt dich als Privatverkäufer vor späteren Ansprüchen hinsichtlich
          des Fahrzeugzustands.
        </p>
        <h2>Schritte zur Eigentumsübertragung:</h2>
        <ul className="nummerierte-antwort">
          <li>
            <h3>Kaufvertrag mit Gewährleistungsausschluss</h3>
            <p>
              Alle Händler, die über Autoeinfachlos kaufen, verwenden unseren
              standardisierten Kaufvertrag, der den Gewährleistungsausschluss
              enthält. Dieser Vertrag sichert dich als Privatverkäufer gegen
              Haftung für mögliche Mängel ab, die nach dem Verkauf auftreten
              könnten. Überprüfe den Vertrag gründlich und stelle sicher, dass
              alle relevanten Details – wie Fahrzeugdaten, Kaufpreis,
              Verkaufsdatum und der Gewährleistungsausschluss – enthalten sind.
            </p>
          </li>
          <li>
            <h3>Automatische Abmeldung des Fahrzeugs durch den Händler</h3>
            <p>
              Nach der Unterzeichnung des Kaufvertrags übernimmt der Händler die
              Abmeldung des Fahrzeugs bei der Zulassungsstelle. So bist du ab
              diesem Zeitpunkt rechtlich nicht mehr als Halter eingetragen und
              trägst keine Verantwortung mehr für mögliche Strafen oder
              Gebühren, die nach dem Verkauf entstehen könnten.
            </p>
          </li>
          <li>
            <h3>Übergabe der Fahrzeugdokumente an den Händler</h3>
            <p>
              Übergib dem Händler alle notwendigen Fahrzeugdokumente,
              einschließlich des Zulassungsscheins (Typenschein), des
              Prüfzertifikats (§57a-Begutachtung, falls vorhanden) und weiterer
              relevanter Unterlagen. Weitere Informationen dazu findest du in
              unserem FAQ:
              <a
                href="/faq/dokumente/fahrzeugverkauf-dokumente"
                target="_blank"
                className="FragenAntworten-link"
              >
                „Welche Dokumente benötige ich, um mein Fahrzeug bei
                Autoeinfachlos zu verkaufen?“
              </a>
            </p>
          </li>
        </ul>
      </>
    ),

    metaTitle:
      "Wie wird der Kaufvertrag bei Autoeinfachlos gestaltet? – Autoeinfachlos",
    metaDescription:
      "Der Kaufvertrag bei Autoeinfachlos enthält einen Gewährleistungsausschluss, der dich schützt. Der Händler übernimmt die Abmeldung und sichert den Verkauf ab",
    link: "/kaufvertrag-gestaltung",
  },
  {
    id: 4,
    title:
      "Warum benötige ich einen Führerschein, um mein Auto über Autoeinfachlos zu verkaufen?",
    text: (
      <>
        <p>Wir benötigen eine gut lesbare Kopie deines Ausweises, um:</p>
        <ul className="gepunktete-antwort">
          <li>deine Identität zu überprüfen</li>
          <li>den Verkauf deines Fahrzeugs zu bestätigen</li>
        </ul>

        <p>Ausweise aus jedem Land werden akzeptiert.</p>
        <h3>Wann du deinen Ausweis hochladen musst:</h3>
        <ul className="gepunktete-antwort">
          <li>
            Während dein Fahrzeug im täglichen Verkauf ist – das spart Zeit,
            sobald ein Verkauf abgeschlossen wird
          </li>
          <li>
            Am Tag der Abholung – dies dient dazu, deine Identität gegenüber dem
            Käufer zu bestätigen
          </li>
        </ul>
        <h3>Wichtige Informationen:</h3>
        <ul className="gepunktete-antwort">
          <li>
            Der Name auf dem Ausweis sollte mit den Angaben im Zulassungsschein
            übereinstimmen.
          </li>
        </ul>
        <h3>Welche Ausweisdokumente sind gültig?</h3>
        <p>
          Wir akzeptieren verschiedene Ausweisdokumente zur Bestätigung deiner
          Identität:
        </p>
        <ul className="gepunktete-antwort">
          <li>Reisepass</li>
          <li>Führerschein</li>
          <li>Personalausweis</li>
        </ul>
      </>
    ),

    metaTitle:
      "Warum benötige ich einen Ausweis für den Verkauf? – Autoeinfachlos",
    metaDescription:
      "Erfahre, warum ein Ausweis beim Fahrzeugverkauf Pflicht ist und welche Dokumente du nutzen kannst, wie Führerschein, Reisepass oder Personalausweis.",
    link: "/ausweis-fahrzeugverkauf",
  },
  {
    id: 5,
    title: "Warum muss ich meine Bankdaten mit Autoeinfachlos teilen?",
    text: (
      <>
        <p>
          Beim Hochladen deiner Dokumente wirst du gebeten, deine Bankdaten
          anzugeben. Dies ermöglicht uns, dir die Zahlung so schnell wie möglich
          zu übermitteln.
        </p>
        <p>
          Deine Bankdaten werden sicher verschlüsselt und geschützt gespeichert.
          Sie werden nur an den Käufer weitergegeben, sobald ein Verkauf
          vereinbart wurde, damit er die Zahlung veranlassen kann.
        </p>
      </>
    ),

    metaTitle:
      "Warum muss ich meine Bankdaten teilen? – Autoeinfachlos erklärt",
    metaDescription:
      "Deine Bankdaten sind notwendig, um die Zahlung nach dem Verkauf zu veranlassen. Sie werden sicher gespeichert und nur an den Käufer weitergegeben",
    link: "/bankdaten-teilen",
  },
  {
    id: 6,
    title:
      "Kann ich ein Auto über Autoeinfachlos im Namen einer anderen Person verkaufen?",
    text: (
      <>
        <p>
          Ja – jedoch benötigen wir einige zusätzliche Dokumente, um
          sicherzustellen, dass der Verkauf korrekt autorisiert ist.
        </p>
        <p>
          Sobald diese Dokumente hochgeladen und vom Dokumententeam von
          Autoeinfachlos geprüft wurden, kannst du (der eingetragene Halter) als
          Zahlungsempfänger für den Fahrzeugverkauf eingerichtet werden.
        </p>
        <p>
          Bitte beachte, dass wir den Verkauf ohne diese Dokumente nicht
          abschließen können.
        </p>
        <h2>Erforderliche Dokumente</h2>
        <ul className="gepunktete-antwort">
          <li>
            <h3>Vollmacht</h3>
            <p>
              Diese muss vom eingetragenen Fahrzeughalter ausgefüllt und
              unterschrieben werden.
            </p>
          </li>
          <li>
            <h3>Foto des Führerscheins des eingetragenen Fahrzeughalters</h3>
            <p>
              Alternativ kann auch ein anderes Lichtbildausweis, wie ein
              Reisepass, eingereicht werden.
            </p>
          </li>
        </ul>
        <p>
          Ohne diese Dokumente kann der eingetragene Halter keine Zahlung für
          das Fahrzeug erhalten.
        </p>
        <h2>Wenn du ein Firmenfahrzeug verkaufst</h2>
        <p>
          Wir benötigen eine unterschriebene Vollmacht und einen
          Identitätsnachweis eines Geschäftsführers.
        </p>
        <h2>
          Falls du ein Fahrzeug aus einem Nachlass verkaufst – im Namen einer
          verstorbenen Person
        </h2>
        <p>
          Unser Kundendienst kann dir hierbei helfen. Rufe sie unter der Nummer
          +43 720 881186 an.
        </p>
        <h2>Wo du deine Dokumente hochladen kannst</h2>
        <p>
          Diese Dokumente können direkt in deinem Autoeinfachlos-Profil
          hochgeladen werden.
        </p>
        <p>
          Solltest du Schwierigkeiten haben, sende die Kopien bitte per E-Mail
          an service@autoeinfachlos.at
        </p>
        <h2>
          Wenn du nicht der Fahrzeugeigentümer bist, weil du ein finanziertes
          Auto verkaufst
        </h2>
        <p>
          Siehe unsere FAQ „Wie verkaufe ich mein finanziertes Auto über
          Autoeinfachlos?“
        </p>
      </>
    ),

    metaTitle:
      "Kann ich ein Auto im Namen einer anderen Person verkaufen? – Autoeinfachlos",
    metaDescription:
      "Ja, mit einer Vollmacht und einem Identitätsnachweis des Halters kannst du ein Auto im Namen einer anderen Person über Autoeinfachlos verkaufen",
    link: "/auto-im-namen-anderer-person-verkaufen",
  },
  {
    id: 7,
    title: "Sind meine Daten und Dokumente sicher und privat?",
    text: (
      <>
        <p>
          Ja, deine Daten und Dokumente sind sicher und bleiben während der
          Auktion privat. Kein Händler sieht deine privaten Informationen wie
          Name, Nachname, Anschrift, Kennzeichen oder Fahrgestellnummer. Erst
          nach einem erfolgreichen Verkauf werden diese Daten an den jeweiligen
          Händler weitergegeben.
        </p>
      </>
    ),

    metaTitle: "Sind meine Daten und Dokumente bei Autoeinfachlos sicher?",
    metaDescription:
      "Ja, deine Daten bleiben während der Auktion privat und werden nur nach einem erfolgreichen Verkauf sicher an den Händler weitergegeben",
    link: "/datensicherheit-und-privatsphaere",
  },
];

export const abholung = [
  {
    id: 1,
    title: "Holt Autoeinfachlos das Auto ab?",
    text: (
      <>
        <p>
          Ja. Wenn du dein Auto über Autoeinfachlos an einen Händler verkaufst,
          wird es kostenlos von dir zu Hause, bei der Arbeit oder an einer
          anderen passenden Adresse abgeholt.
        </p>

        <p>Bitte beachte:</p>
        <ul className="gepunktete-antwort">
          <li>
            <p>
              Wir empfehlen, dass Abholungen vor 19 Uhr stattfinden. Falls du
              einen späteren Abholtermin vereinbarst, muss der Händler uns dein
              schriftliches Einverständnis (per E-Mail akzeptiert) für eine
              späte Abholung senden.
            </p>
          </li>
          <li>
            <p>
              Bei der Abholung führt der Händler eine kurze Inspektion durch, um
              sicherzustellen, dass alle Angaben übereinstimmen. Die Inspektion
              dauert nicht länger als 30 Minuten – du kannst dabei zuschauen
              oder es dir in der Zwischenzeit zu Hause bequem machen.
            </p>
          </li>
        </ul>
      </>
    ),
    metaTitle: "Holt Autoeinfachlos mein Auto ab? – Autoeinfachlos erklärt",
    metaDescription:
      "Ja, dein Auto wird kostenlos von dir zu Hause, bei der Arbeit oder an einem passenden Ort abgeholt. Eine kurze Inspektion ist Teil des Prozesses",
    link: "/auto-abholung",
  },
  {
    id: 2,
    title: "Was passiert am Tag der Abholung?",
    text: (
      <>
        <p>
          Bei der Abholung wird der Händler dein Fahrzeug inspizieren, um
          sicherzustellen, dass es den von dir angegebenen Details und Fotos
          entspricht. Dies beinhaltet in der Regel eine kurze Überprüfung der
          Karosserie, des Innenraums und der allgemeinen Mechanik und kann eine
          kurze Probefahrt umfassen.
        </p>
        <p>
          Sobald der Händler bestätigt hat, dass das Fahrzeug wie beschrieben
          ist, wird die Zahlung an dich und/oder deine Finanzierungsbank
          veranlasst, die Papiere werden unterzeichnet, und der Händler nimmt
          das Auto mit.
        </p>
      </>
    ),
    metaTitle: "Was passiert am Tag der Abholung? – Autoeinfachlos erklärt",
    metaDescription:
      "Am Abholtag prüft der Händler dein Fahrzeug, bestätigt die Angaben und leitet die Zahlung ein. Danach werden die Papiere unterzeichnet und das Auto mitgenommen",
    link: "/tag-der-abholung",
  },
  {
    id: 3,
    title: "Wer wird mein Fahrzeug abholen?",
    text: (
      <>
        <p>
          Unser Netzwerk aus verifizierten Händlern kann entweder einen eigenen
          Mitarbeiter zur Abholung deines Fahrzeugs schicken oder unseren
          eigenen Transportservice,
          <a href="/" target="_blank" className="FragenAntworten-link">
            Autoeinfachlos Transport
          </a>
          , nutzen. In beiden Fällen ist die Abholung für dich völlig kostenlos
          und findet an deiner gewünschten Adresse statt – in der Regel zu Hause
          oder am Arbeitsplatz.
        </p>
      </>
    ),

    metaTitle: "Wer holt mein Fahrzeug ab? – Autoeinfachlos erklärt",
    metaDescription:
      "Dein Fahrzeug wird von einem verifizierten Händler oder unserem Autoeinfachlos Transportservice kostenlos an deiner gewünschten Adresse abgeholt",
    link: "/wer-holt-fahrzeug-ab",
  },
  {
    id: 4,
    title: "Was muss ich am Tag des Verkaufs bereit haben?",
    text: (
      <>
        <p>
          Sobald du einen Termin für die Abholung oder Übergabe deines Fahrzeugs
          vereinbart hast, solltest du einige Dokumente bereithalten, damit der
          ausgewählte Händler die Fahrzeugdaten überprüfen, das Geld auf dein
          Bankkonto überweisen und den Kaufvertrag abschließen kann. Wenn du
          diese Unterlagen im Voraus vorbereitest, wird der Übergabetag so
          schnell und reibungslos wie möglich ablaufen.
        </p>
        <p>Du solltest folgende Unterlagen bereithalten:</p>
        <h3>Wenn du der eingetragene Halter des Fahrzeugs bist:</h3>
        <ul className="gepunktete-antwort">
          <li>Zulassungsbescheinigung Teil 1</li>
          <li>Zulassungsbescheinigung Teil 2</li>
          <li>alle noch vorhandenen Fahrzeugschlüssel</li>
          <li>deinen gültigen Personalausweis oder Reisepass</li>
          <li>
            Genehmigung der Finanzierungsbank (bei bestehender Finanzierung
            benötigen wir ein Schreiben mit der Schlussabrechnung)
          </li>
        </ul>

        <h3>Falls vorhanden, bringst du bitte auch folgenden Dinge mit:</h3>
        <ul className="gepunktete-antwort">
          <li>zugehöriges Service-Heft</li>
          <li>Das letzte §57a-Gutachten</li>
          <li>
            vorhandene Rechnungen und Belege (Neuwagenkauf, Service, Reparaturen
            etc.)
          </li>
          <li>zweiten Satz Räder (sofern angegeben)</li>
        </ul>
        <h3>Wenn du nicht der eingetragene Halter des Fahrzeugs bist:</h3>
        <p>Alle oben genannten Unterlagen sowie:</p>
        <ul className="gepunktete-antwort">
          <li>
            Schriftliche Vollmacht des eingetragenen Halters, dass du das
            Fahrzeug verkaufen darfst
          </li>
          <li>
            Lichtbildausweis (Führerschein oder Reisepass) des eingetragenen
            Halters
          </li>
        </ul>
      </>
    ),

    metaTitle:
      "Was muss ich am Tag des Verkaufs bereithalten? – Autoeinfachlos erklärt",
    metaDescription:
      "Halte Zulassungsbescheinigungen, Schlüssel, Ausweis und Serviceunterlagen bereit. Bei Finanzierung oder im Namen anderer Personen sind weitere Dokumente erforderlich",
    link: "/unterlagen-am-tag-des-verkaufs",
  },
  {
    id: 5,
    title: "Wie lange dauert es, bis das Fahrzeug abgeholt wird?",
    text: (
      <>
        <p>
          Sobald der Verkauf offiziell vereinbart ist, erfolgt die Abholung des
          Fahrzeugs in der Regel innerhalb von drei bis fünf Werktagen.
        </p>
      </>
    ),

    metaTitle:
      "Wie lange dauert es, bis mein Fahrzeug abgeholt wird? – Autoeinfachlos",
    metaDescription:
      "Nach Vereinbarung des Verkaufs wird dein Fahrzeug in der Regel innerhalb von drei bis fünf Werktagen kostenlos abgeholt",
    link: "/fahrzeug-abholzeitraum",
  },
  {
    id: 6,
    title: "Kann ich ein Abholdatum festlegen?",
    text: (
      <>
        <p>
          Ja – der Händler wird sich innerhalb eines Werktages nach Annahme des
          Angebots mit dir in Verbindung setzen, um einen Abholtermin zu
          vereinbaren.
        </p>
        <p>
          Du kannst dann ein Datum und eine Uhrzeit auswählen, die dir passen.
        </p>
        <p>
          Der Vertreter des Händlers oder ein Mitarbeiter unseres eigenen
          Abholdienstes, kommt zum vereinbarten Zeitpunkt zu dir nach Hause oder
          an deinen Arbeitsplatz, um das Fahrzeug zu inspizieren, abzuholen und
          die Zahlung schnell und unkompliziert zu veranlassen.
        </p>
      </>
    ),

    metaTitle: "Kann ich ein Abholdatum festlegen? – Autoeinfachlos erklärt",
    metaDescription:
      "Ja, nach Annahme des Angebots kannst du ein passendes Datum und eine Uhrzeit mit dem Händler vereinbaren, um die Abholung deines Fahrzeugs zu organisieren",
    link: "/abholdatum-festlegen",
  },
  {
    id: 7,
    title:
      "Wird der Händler versuchen, den Verkaufspreis am Abholtag zu ändern?",
    text: (
      <>
        <p>
          Das Angebot, das du für dein Fahrzeug erhältst, basiert auf den
          Angaben, die du in deinem Profil gemacht hast. Wenn diese Angaben
          korrekt sind, dürfen unsere verifizierten Händler bei der Abholung
          deines Fahrzeugs den Preis nicht neu verhandeln. Sie sollten lediglich
          das Fahrzeug inspizieren, den Zustand überprüfen und dann die
          vereinbarte Zahlung auf dein Bankkonto überweisen.
        </p>
        <p>
          Sollte das Fahrzeug jedoch abweichend beschrieben worden sein und
          zusätzliche Mängel oder Schäden aufweisen, die im Profil nicht
          angegeben wurden, kann der Händler sein Angebot zurückziehen oder
          einen neuen Preis vorschlagen. Wenn das überarbeitete Angebot für dich
          nicht akzeptabel ist, hast du die Möglichkeit, jederzeit vom Verkauf
          zurückzutreten. Alternativ kannst du uns anrufen, um uns den Schaden
          beurteilen zu lassen und mit dem Händler in deinem Namen zu
          verhandeln.
        </p>
        <p>
          Um Fairness zu gewährleisten, sind die Händler verpflichtet, Fotos von
          unangegebenen Schäden zu machen und uns diese als Nachweis für etwaige
          Preisänderungen vorzulegen.
        </p>
      </>
    ),

    metaTitle: "Wird der Verkaufspreis am Abholtag geändert? – Autoeinfachlos",
    metaDescription:
      "Der Preis bleibt, wenn dein Fahrzeug wie im Profil beschrieben ist. Bei ungenannten Schäden kann der Händler ein neues Angebot machen oder du kannst vom Verkauf zurücktreten",
    link: "/verkaufspreis-am-abholtag",
  },
  {
    id: 8,
    title:
      "Was passiert, wenn der Fahrer mein Fahrzeug während der Probefahrt beschädigt?",
    text: (
      <>
        <p>
          Alle Händler und deren Vertreter sind versichert, um die Fahrzeuge,
          die sie inspizieren und abholen, zu fahren. Falls dein Fahrzeug
          während der Probefahrt beschädigt wird, werden die Reparaturkosten
          vollständig übernommen.
        </p>
      </>
    ),

    metaTitle:
      "Was passiert, wenn mein Fahrzeug bei der Probefahrt beschädigt wird? – Autoeinfachlos",
    metaDescription:
      "Alle Händler sind versichert. Sollte dein Fahrzeug während der Probefahrt beschädigt werden, werden die Reparaturkosten vollständig übernommen",
    link: "/schaden-waehrend-probefahrt",
  },
  {
    id: 9,
    title:
      "Warum muss ich einen Ausweis vorzeigen, wenn mein Fahrzeug abgeholt wird?",
    text: (
      <>
        <p>
          Dies dient Sicherheitsgründen und ist ein üblicher Prozess beim Kauf
          und Verkauf von Fahrzeugen. Der Käufer muss sicherstellen, dass du
          berechtigt bist, das Fahrzeug zu verkaufen. Zu deinem Schutz muss sich
          auch der Vertreter des Händlers bei dir ausweisen. Sollte dies nicht
          geschehen, kontaktiere bitte unseren Kundendienst.
        </p>
      </>
    ),

    metaTitle:
      "Warum muss ich einen Ausweis bei der Abholung vorzeigen? – Autoeinfachlos",
    metaDescription:
      "Ein Ausweis bestätigt deine Berechtigung, das Fahrzeug zu verkaufen. Auch der Händlervertreter muss sich ausweisen, um deine Sicherheit zu gewährleisten",
    link: "/ausweis-bei-abholung",
  },
  {
    id: 10,
    title: "Was mache ich, wenn der Händler sich nicht bei mir meldet?",
    text: (
      <>
        <p>
          Wir haben ein engagiertes Verkaufssupport-Team, das dir bei allen
          Fragen und Problemen nach dem Verkauf deines Fahrzeugs zur Verfügung
          steht – auch wenn der Händler sich nicht meldet. Dies kommt sehr
          selten vor, kann jedoch passieren. Falls du innerhalb von 24 Stunden
          nichts vom Händler hörst, wende dich bitte an unser
          Verkaufssupport-Team oder rufe uns direkt unter der Nummer +43 720
          881186 an.
        </p>
        <p>
          Ein Teammitglied wird dir weiterhelfen und den Händler direkt
          kontaktieren, um die Abholung des Fahrzeugs so schnell wie möglich zu
          arrangieren. Sollte der Händler weiterhin keinen Kontakt aufnehmen,
          kann Autoeinfachlos dir alternativ einen anderen Käufer für dein
          Fahrzeug vermitteln.
        </p>
      </>
    ),

    metaTitle: "Was tun, wenn der Händler sich nicht meldet? – Autoeinfachlos",
    metaDescription:
      "Wenn der Händler sich nicht meldet, kontaktiere unser Verkaufssupport-Team. Wir helfen dir weiter oder arrangieren alternativ einen neuen Käufer",
    link: "/haendler-meldet-sich-nicht",
  },
];

export const bezahlung = [
  {
    id: 1,
    title: "Wie und wann werde ich für mein Fahrzeug bezahlt?",
    text: (
      <>
        <p>
          Alle Händler, mit denen wir zusammenarbeiten, organisieren eine
          kostenlose Abholung – von deinem Zuhause, Arbeitsplatz oder einem
          anderen geeigneten Ort – und veranlassen eine schnelle Zahlung
          innerhalb von 24 Stunden, ebenfalls kostenfrei.
        </p>
        <p>
          Am Abholtag wird der Händler oder ein Teammitglied dein Auto
          inspizieren, um sicherzustellen, dass es der Beschreibung entspricht,
          die du angegeben hast. Dies umfasst in der Regel eine kurze
          Überprüfung der Karosserie, des Innenraums und der Mechanik, manchmal
          auch eine kurze Probefahrt.
        </p>
        <p>
          Wenn du dein Fahrzeug korrekt beschrieben hast, verpflichtet sich der
          Händler, den vereinbarten Betrag basierend auf deinem höchsten Angebot
          zu zahlen. Der Händler wird nur dann einen niedrigeren Betrag
          vorschlagen, wenn am Abholtag etwas wesentlich von den Angaben in
          deinem Profil abweicht. Deshalb ist es wichtig, das Fahrzeugprofil so
          genau wie möglich zu erstellen, um das Risiko einer Preisreduzierung
          zu minimieren.
        </p>
        <p>
          Sobald der Händler bestätigt hat, dass das Fahrzeug der Beschreibung
          entspricht, wird eine schnelle, kostenlose Zahlung per
          Online-Überweisung veranlasst. In den meisten Fällen erfolgt die
          Überweisung am selben Tag der Abholung auf das von dir angegebene
          Bankkonto, das du vor der Zahlung mit dem Händler bestätigen kannst.
        </p>
        <p>
          Die Dauer, bis das Geld auf deinem Konto eingeht, kann je nach Händler
          und Bank leicht variieren. In den meisten Fällen ist das Geld vor der
          Abfahrt des Fahrzeugs auf deinem Konto oder spätestens innerhalb von
          24 Stunden nach der Abholung.
        </p>
        <p>
          Falls noch offene Finanzierungen auf dem Fahrzeug bestehen, werden
          diese zuerst beglichen, bevor du dein Geld erhältst. Weitere
          Informationen zur Ablösung von Finanzierungen findest du
          <a
            href="/faq/bezahlung/verkaufspreis-hoeher-als-finanzierung"
            target="_blank"
            className="FragenAntworten-link"
          >
            hier
          </a>
          .
        </p>
        <p>
          Bitte beachte: Keiner unserer Händler kann dich in bar (d. h. in
          Banknoten) auszahlen.
        </p>
      </>
    ),
    metaTitle:
      "Wie und wann werde ich für mein Fahrzeug bezahlt? – Autoeinfachlos",
    metaDescription:
      "Die Zahlung erfolgt per Überweisung innerhalb von 24 Stunden nach der Abholung. Voraussetzung ist, dass das Fahrzeug der Beschreibung entspricht",
    link: "/fahrzeug-bezahlung",
  },
  {
    id: 2,
    title: "Wann erhalte ich das Geld für mein Fahrzeug?",
    text: (
      <>
        <p>
          Die Zahlung erfolgt per Banküberweisung. In den meisten Fällen wird
          das Geld am selben Tag der Abholung des Fahrzeugs überwiesen, immer
          per Online-Überweisung auf das von dir angegebene Bankkonto. Diese
          Kontodaten bestätigst du, sobald du ein Angebot für dein Fahrzeug
          angenommen hast. Die Dauer, bis das Geld auf deinem Konto eingeht,
          kann je nach Händler und Bank leicht variieren.
        </p>
        <p>
          Falls noch eine offene Finanzierung auf dem Fahrzeug besteht, wird
          diese zuerst beglichen, bevor du den Restbetrag erhältst. Weitere
          Informationen zur Ablösung von Finanzierungen findest du
          <a href="/" target="_blank" className="FragenAntworten-link">
            hier
          </a>
        </p>
        <p>
          Bitte beachte: Keiner unserer Händler kann dich in bar (d. h. in
          Banknoten) auszahlen.
        </p>
      </>
    ),
    metaTitle: "Wann erhalte ich mein Geld für das Fahrzeug? – Autoeinfachlos",
    metaDescription:
      "Die Zahlung erfolgt per Überweisung am Tag der Abholung oder innerhalb von 24 Stunden. Offene Finanzierungen werden vor der Auszahlung beglichen",
    link: "/zahlungszeitpunkt",
  },
  {
    id: 3,
    title: "Wer wird mich bezahlen?",
    text: (
      <>
        <p>
          Die Zahlung für den Verkauf deines Fahrzeugs erfolgt direkt vom
          kaufenden Händler. Das Geld wird auf das Bankkonto des Verkäufers
          überwiesen.
        </p>
      </>
    ),

    metaTitle: "Wer wird mich bezahlen? – Autoeinfachlos erklärt",
    metaDescription:
      "Die Zahlung erfolgt direkt vom kaufenden Händler und wird sicher auf das von dir angegebene Bankkonto überwiesen",
    link: "/wer-bezahlt-mich",
  },
  {
    id: 4,
    title: "Wird der Händler mein Fahrzeug vor der Abholung bezahlen?",
    text: (
      <>
        <p>
          Nein. Der Händler muss das Fahrzeug zunächst inspizieren und
          möglicherweise eine kurze Probefahrt machen, um sicherzustellen, dass
          die Angaben in deinem Fahrzeugprofil korrekt sind. Diese Überprüfung
          findet immer vor der Zahlung statt.
        </p>
      </>
    ),

    metaTitle: "Wird der Händler vor der Abholung bezahlen? – Autoeinfachlos",
    metaDescription:
      "Nein, der Händler inspiziert dein Fahrzeug zuerst, um die Angaben zu überprüfen. Die Zahlung erfolgt nach der Überprüfung, vor oder kurz nach der Abholung",
    link: "/zahlung-vor-abholung",
  },
  {
    id: 5,
    title: "Zahlt Autoeinfachlos offene Finanzierungen ab?",
    text: (
      <>
        <p>
          Alle Händler von Autoeinfachlos können Fahrzeuge mit laufender
          Finanzierung kaufen. Am Tag der Abholung wird der Händler die offene
          Finanzierung direkt mit deiner Finanzierungsbank begleichen, und der
          verbleibende Betrag wird per Überweisung auf das von dir angegebene
          Bankkonto überwiesen.
        </p>
        <p>
          Um ein finanziertes Fahrzeug zu verkaufen, benötigst du eine
          Ablösesumme von deinem Finanzierungsanbieter als
          „Abrechnungserklärung“. Diese gibt den genauen Betrag an, der
          beglichen werden muss, bevor der Finanzierungsvertrag beendet werden
          kann.
        </p>
        <p>
          Sobald du die Ablösesumme erhalten hast, ist dieser normalerweise für
          einen Zeitraum von 14 Tagen gültig. Du musst dein Fahrzeug innerhalb
          dieses Zeitraums verkaufen oder eine neue Schlussabrechnung anfordern.
          Der Händler wird dir den einfachen Ablauf der Abwicklung erklären,
          sobald du fortfährst.
        </p>
        <p>
          Falls dein Schlussbetrag höher als dein Verkaufsangebot ist
          (sogenannte negative Eigenkapital), solltest du die Differenz an den
          Händler zahlen, der dann die gesamte Summe bei deiner
          Finanzierungsbank ablöst. Weitere Informationen findest du in unserer
          FAQ „Wie verkaufe ich mein finanziertes Auto über Autoeinfachlos?”
        </p>
      </>
    ),

    metaTitle:
      "Zahlt Autoeinfachlos offene Finanzierungen ab? – Autoeinfachlos",
    metaDescription:
      "Ja, Händler bei Autoeinfachlos begleichen offene Finanzierungen direkt mit deiner Bank. Der Restbetrag wird dir per Überweisung ausgezahlt",
    link: "/finanzierung-abloesen",
  },
  {
    id: 6,
    title:
      "Was passiert, wenn mein Fahrzeug finanziert ist und der Verkaufspreis höher ist als der offene Finanzierungsbetrag?",
    text: (
      <>
        <p>
          Wenn der Händler die Finanzierung für dich ablöst, musst du eine
          gültige Abrechnungserklärung vorlegen, die den offenen Betrag und die
          Vertragsreferenz enthält. Der Händler wird zunächst den offenen
          Finanzierungsbetrag begleichen, und der restliche Betrag wird dann auf
          dein Bankkonto überwiesen.
        </p>
        <p>
          Falls du die Finanzierung selbst ablöst, musst du eine Bestätigung
          vorlegen, dass die Finanzierung vollständig beglichen ist. In diesem
          Fall wird der Händler den gesamten Verkaufserlös auf dein Bankkonto
          überweisen.
        </p>
        <p>
          Falls der Finanzierungsbetrag höher ist als der Verkaufspreis des
          Fahrzeugs, wird der Händler dich kontaktieren, um das weitere Vorgehen
          zu besprechen.
        </p>
      </>
    ),

    metaTitle:
      "Was, wenn der Verkaufspreis höher ist als der Finanzierungsbetrag? – Autoeinfachlos",
    metaDescription:
      "Wenn der Verkaufspreis höher ist, begleicht der Händler den Finanzierungsbetrag und überweist dir den Rest auf dein Bankkonto. Erfahre mehr über den Ablauf",
    link: "/verkaufspreis-hoeher-als-finanzierung",
  },
  {
    id: 7,
    title: "Warum können wir keine Sofortzahlung für mein Fahrzeug anbieten?",
    text: (
      <>
        <p>
          Obwohl die meisten unserer Händler eine Sofortzahlung anbieten, nutzen
          einige der größeren Autohäuser Buchhaltungssysteme, die Zahlungen nur
          in bestimmten Zeiträumen oder zu festgelegten Tageszeiten verarbeiten.
        </p>
        <p>
          Wenn dein Fahrzeug finanziert ist, nimmt die Zahlungsabwicklung
          ebenfalls mehr Zeit in Anspruch. Finanzierungsbanken nutzen in der
          Regel Clearingstellen, um Betrugsprüfungen durchzuführen, bevor die
          Zahlung bearbeitet wird. Diese finanziellen Überprüfungen benötigen
          normalerweise mindestens ein bis zwei Werktage.
        </p>
      </>
    ),

    metaTitle:
      "Warum bietet Autoeinfachlos keine Sofortzahlung an? – Autoeinfachlos",
    metaDescription:
      "Einige Händler und Banken benötigen Zeit für Buchhaltungsprozesse und Prüfungen. Zahlungen erfolgen in der Regel innerhalb von ein bis zwei Werktagen",
    link: "/sofortzahlung-nicht-verfuegbar",
  },
  {
    id: 8,
    title:
      "Der Händler, der mein Fahrzeug gekauft hat, bietet keine Sofortzahlung an. Welche Garantien habe ich?",
    text: (
      <>
        <p>
          Wenn der Händler keine Sofortzahlung anbietet, stellt er dir ein
          rechtlich bindendes Kaufnachweisdokument für dein Fahrzeug zur
          Verfügung. Üblicherweise wird dir dieses Dokument per E-Mail vom
          Autohaus zugesandt, und die Zahlung sollte innerhalb von 24 Stunden
          nach der Abholung des Fahrzeugs erfolgen.
        </p>
        <p>
          Wir bei Autoeinfachlos garantieren deine Zahlung und stehen dir
          jederzeit bei Fragen zur Verfügung. Kontaktiere dazu unseren
          Kundendienst unter der Nummer: +43 720 881186.
        </p>
      </>
    ),

    metaTitle:
      "Welche Garantien habe ich, wenn keine Sofortzahlung erfolgt? – Autoeinfachlos",
    metaDescription:
      "Auch ohne Sofortzahlung erhältst du ein rechtlich bindendes Kaufdokument. Autoeinfachlos garantiert deine Zahlung und unterstützt dich bei Fragen",
    link: "/garantie-bei-keiner-sofortzahlung",
  },
];

export const fahrzeugueberwachungsTool = [
  {
    id: 1,
    title:
      "Wo kann ich meine monatlichen Benachrichtigungen für das Fahrzeugwert-Überwachungstool verwalten?",
    text: (
      <>
        <p>
          Du kannst die individuellen Benachrichtigungen für dein(e) Fahrzeug(e)
          auf deiner
          <a href="/" target="_blank" className="FragenAntworten-link">
            Kontoseite
          </a>
          verwalten oder indem du auf das Glockensymbol auf der Ergebnisseite
          für jedes Fahrzeug klickst.
        </p>
      </>
    ),
    metaTitle:
      "Wo kann ich Benachrichtigungen für das Fahrzeugwert-Tool verwalten? – Autoeinfachlos",
    metaDescription:
      "Verwalte Benachrichtigungen für dein Fahrzeugwert-Tool auf deiner Kontoseite oder direkt über das Glockensymbol auf der Ergebnisseite",
    link: "/benachrichtigungen-verwalten",
  },
  {
    id: 2,
    title:
      "Berücksichtigt das Fahrzeugwert-Überwachungstool den Zustand meines Fahrzeugs?",
    text: (
      <>
        <p>
          Das Fahrzeugwert-Überwachungstool basiert auf grundlegenden Angaben
          wie Marke, Modell, Alter, Kilometerstand und Sonderausstattung des
          Fahrzeugs und geht dabei davon aus, dass es sich in ausgezeichnetem
          Zustand befindet.
        </p>
        <p>
          Zusätzlich berücksichtigt das Bewertungstool die aktuellen Angebote
          und die Nachfrage auf dem österreichischen Gebrauchtwagenmarkt, um
          eine genauere Einschätzung zu liefern.
        </p>
      </>
    ),
    metaTitle:
      "Berücksichtigt das Fahrzeugwert-Tool den Zustand meines Fahrzeugs? – Autoeinfachlos",
    metaDescription:
      "Das Fahrzeugwert-Tool berücksichtigt Marke, Modell, Sonderausstattung und Kilometerstand und geht von einem ausgezeichneten Zustand aus. Aktuelle Marktdaten fließen ebenfalls ein",
    link: "/zustand-beruecksichtigung",
  },
  {
    id: 3,
    title:
      "Wie oft erhalte ich eine E-Mail-Benachrichtigung vom Fahrzeugwert-Überwachungstool?",
    text: (
      <>
        <p>
          Wenn du die E-Mail-Benachrichtigungen des
          Fahrzeugwert-Überwachungstools aktivierst, erhältst du alle 30 Tage
          eine Aktualisierung des aktuellen Werts deines Fahrzeugs auf dem
          Gebrauchtwagenmarkt. Falls du inzwischen mehr Kilometer gefahren bist,
          kannst du deinen Kilometerstand in deinem Profil aktualisieren, um
          eine genauere Bewertung zu erhalten.
        </p>
      </>
    ),

    metaTitle:
      "Wie oft erhalte ich E-Mails vom Fahrzeugwert-Tool? – Autoeinfachlos",
    metaDescription:
      "Das Fahrzeugwert-Tool sendet dir alle 30 Tage eine E-Mail mit dem aktuellen Wert deines Autos. Aktualisiere deinen Kilometerstand für präzisere Bewertungen",
    link: "/email-benachrichtigungen-haeufigkeit",
  },
  {
    id: 4,
    title: "Kann ich mehrere Fahrzeuge verfolgen?",
    text: (
      <>
        <p>
          Ja, wenn du ein Profil bei Autoeinfachlos hast, kannst du bis zu sechs
          Fahrzeuge gleichzeitig verfolgen.
        </p>
      </>
    ),

    metaTitle:
      "Kann ich mehrere Fahrzeuge mit dem Fahrzeugwert-Tool verfolgen? – Autoeinfachlos",
    metaDescription:
      "Ja, du kannst mit deinem Autoeinfachlos-Profil bis zu sechs Fahrzeuge gleichzeitig verfolgen und ihren Wert überwachen",
    link: "/mehrere-fahrzeuge-verfolgen",
  },
  {
    id: 5,
    title:
      "Bekomme ich beim Verkauf meines Autos über Autoeinfachlos den vollen Preis, den das Fahrzeugwert-Überwachungstool anzeigt?",
    text: (
      <>
        <p>
          Es besteht eine geringe Wahrscheinlichkeit, dass die Bewertung im
          Fahrzeugwert-Überwachungstool von der Bewertung abweicht, die du beim
          Verkaufsprozess über Autoeinfachlos erhältst. Das liegt daran, dass
          die Bewertungen in Echtzeit berechnet werden und sich die Daten
          zwischen der Bewertung im Überwachungstool und dem Verkaufszeitpunkt
          ändern können.
        </p>
      </>
    ),

    metaTitle:
      "Erhalte ich den vollen Preis, den das Fahrzeugwert-Tool anzeigt? – Autoeinfachlos",
    metaDescription:
      "Der Wert im Fahrzeugwert-Tool kann leicht von der finalen Bewertung abweichen, da die Daten in Echtzeit basieren und sich bis zum Verkaufszeitpunkt ändern können",
    link: "/voller-preis-fahrzeugwert-tool",
  },
  {
    id: 6,
    title:
      "Bietet das Fahrzeugwert-Überwachungstool Bewertungen für alle Fahrzeugtypen an?",
    text: (
      <>
        <p>
          Derzeit unterstützt das Fahrzeugwert-Überwachungstool alle Automarken
          dabei, den Wert ihrer Fahrzeuge zu verfolgen.
        </p>
      </>
    ),

    metaTitle:
      "Bietet das Fahrzeugwert-Tool Bewertungen für alle Fahrzeugtypen an? – Autoeinfachlos ",
    metaDescription:
      "Ja, das Fahrzeugwert-Tool unterstützt Bewertungen für alle Automarken, damit du den Wert deines Fahrzeugs einfach verfolgen kannst",
    link: "/bewertungen-alle-fahrzeugtypen",
  },
  {
    id: 7,
    title: "Woher stammen die Daten im Fahrzeugwert-Überwachungstool?",
    text: (
      <>
        <p>
          Für die aktuelle Bewertung nutzt die intelligente
          Bewertungstechnologie von Autoeinfachlos Live-Marktdaten verschiedener
          Gebrauchtwagen-Verkaufsplattformen und Informationen aus Tausenden
          erfolgreicher Verkäufe, um den aktuellen Wert deines Fahrzeugs präzise
          zu schätzen.
        </p>
        <p>
          Neben aktuellen Daten analysieren wir auch kürzlich eingetretene
          historische Werte, um den Preisverlauf und die Entwicklung basierend
          auf Alter, Marke und Modell deines Fahrzeugs zu verstehen. Zudem
          werden alle Bewertungen berücksichtigt, die du auf der
          Autoeinfachlos-Website durchgeführt hast, sofern verfügbar.
        </p>
        <p>
          In deinem Profil kannst du nachverfolgen, wie sich der Wert deines
          Fahrzeugs seit deiner Eintragung über die Monate hinweg entwickelt
          hat.
        </p>
      </>
    ),

    metaTitle: "Woher stammen die Daten im Fahrzeugwert-Tool? – Autoeinfachlos",
    metaDescription:
      "Das Fahrzeugwert-Tool nutzt Live-Marktdaten, historische Preise und erfolgreiche Verkäufe, um den Wert deines Fahrzeugs präzise zu schätzen",
    link: "/datenherkunft",
  },
];
